webpackJsonp([0],{

/***/ "1NID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-enterpreneur FormEnterpreneur.vue"},[_c('div',{staticClass:"switch__container"},[_c('input',{staticClass:"switch",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"value":_vm.value}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "23dS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_checkbox_svg__ = __webpack_require__("kk2J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_checkbox_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_checkbox_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus__ = __webpack_require__("Jn6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vivus__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkBox',
  data: function data() {
    return {
      timeoutPointer: false,
      anim: false
    };
  },

  props: {
    delay: {
      'type': Number,
      'default': 900
    },
    duration: {
      'type': Number,
      'default': 50
    },
    text: {
      'type': String,
      'default': 'text'
    }
  },
  mounted: function mounted() {
    //      let anim = new vivus(this.$el, {
    //        start: 'manual', // avoid memory leak o scroll event
    //        duration: this.duration,
    //        animTimingFunction: vivus.EASE_IN,
    //      });
    //      this.anim = anim;
    //      anim.reset().stop();
    //      this.timeoutPointer = setTimeout(() => {
    //        try {
    //          anim.play();
    //        } catch (e) {
    //        }
    //      }, this.delay);

  },
  beforeDestroy: function beforeDestroy() {
    //      clearTimeout(this.timeoutPointer);
    //      this.anim.stop().destroy();
  },

  components: {
    checkIcon: __WEBPACK_IMPORTED_MODULE_0__assets_checkbox_svg___default.a
  }
});

/***/ }),

/***/ "25eS":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"icon404",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1102 606","width":"582"}},[_c('path',{staticClass:"st0",attrs:{"d":"M680.4 76.4l-36.6 36.5","id":"cilio3"}}),_c('path',{staticClass:"st0",attrs:{"d":"M552.6 43v51.7","id":"cilio2"}}),_c('path',{staticClass:"st0",attrs:{"d":"M429 76.4l36.5 36.5","id":"cilio1"}}),_c('path',{attrs:{"d":"M553.1 294c-15.1 0-27.4 12.3-27.4 27.4 0 15.1 12.3 27.4 27.4 27.4s27.4-12.3 27.4-27.4c0-15.1-12.3-27.4-27.4-27.4zm6.2 21.7c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7s-2.5 5.7-5.7 5.7z","id":"olho"}}),_c('g',{attrs:{"id":"numeros"}},[_c('path',{attrs:{"d":"M554 133.5c105.3 0 157.3 90.5 157.3 186.6 0 97-52 188.4-158.7 188.4s-157.8-89.1-157.8-186.6c0-95.6 53.4-188.4 159.2-188.4zm-.9 290.5c51 0 65.9-62.2 65.9-102.6 0-40.8-13.5-103.5-65.9-103.5-52 0-65.4 62.7-65.4 103.5-.1 40.4 14.3 102.6 65.4 102.6z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M213.3 435.2H37v-90.5l160.6-205.1h106.3v218.6h54.3v77h-54.3V503h-90.5v-67.8zm0-197.7l-94.7 120.7h94.7V237.5zM920.1 435.2H743.8v-90.5l160.6-205.1h106.3v218.6h54.3v77h-54.3V503h-90.5v-67.8zm0-197.7l-94.7 120.7h94.7V237.5z"}})])])}}};

/***/ }),

/***/ "2QZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "51ZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thanks Thanks.vue full-container"},[_c('div',{staticClass:"thanks__content"},[_c('h1',{staticClass:"title-primary hero animated fadeInUp delay1000ms"},[_c('i',{staticClass:"arrow simple left big animated"}),_vm._v(_vm._s(_vm.guestName)),_c('i',{staticClass:"arrow simple big"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"social animated fadeInUp delay1000ms"},[_c('a',{staticClass:"box-social",attrs:{"href":"https://www.facebook.com/boldcomunicacao/","target":"_blank"}},[_c('icoFace'),_vm._v(" "),_c('span',[_vm._v("Curta")])],1),_vm._v(" "),_c('a',{staticClass:"box-social",attrs:{"href":"https://www.instagram.com/boldcomunicacao","target":"_blank"}},[_c('icoInsta'),_vm._v(" "),_c('span',[_vm._v("Siga")])],1),_vm._v(" "),_c('a',{staticClass:"box-social",attrs:{"href":"https://www.youtube.com/channel/UCyp4B226-dw25ROkQujTXtw","target":"_blank"}},[_c('icoYoutube'),_vm._v(" "),_c('span',[_vm._v("Inscreva-se")])],1)]),_vm._v(" "),_c('logo',{staticClass:"thanks__logo animated fadeInUp delay1000ms"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title-primary animated fadeInUp delay1000ms"},[_vm._v("Massa! Você está mais próximo de se tornar "),_c('span',{staticClass:"sub"},[_vm._v("Bold!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-second animated fadeInUp delay1000ms"},[_vm._v("Enquanto aguarda nossa resposta,"),_c('br'),_vm._v("curte as nossas páginas nas redes sociais:")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5DZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('nav',{staticClass:"main-nav navbar navbar-light bg-light"},[_c('div',{staticClass:"navbar-brand"},[_c('logoMinimal',{staticClass:"animated fadeIn"})],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links mr"},[_c('a',{attrs:{"href":"https://www.boldcomunicacao.com.br/blog","target":"_blank"}},[_vm._v("Blog")]),_vm._v(" "),_c('a',{attrs:{"href":"#/contact"}},[_vm._v("Contato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Iau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__ = __webpack_require__("dL6C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271d91dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__ = __webpack_require__("PqxF");
function injectStyle (ssrContext) {
  __webpack_require__("caGv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271d91dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Spv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxSwitcher_vue__ = __webpack_require__("vGO1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a989582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxSwitcher_vue__ = __webpack_require__("1NID");
function injectStyle (ssrContext) {
  __webpack_require__("YdDI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a989582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5XGC":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"ico-insta",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-11216.917 -12404.423 21.854 21.856","width":"23","height":"23"}},[_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Union_1","data-name":"Union 1","d":"M5.768 21.856A5.854 5.854 0 0 1 0 15.959V5.9A5.854 5.854 0 0 1 5.768 0h10.318a5.882 5.882 0 0 1 5.768 5.833v10.126a5.854 5.854 0 0 1-5.768 5.9zM1.985 5.96v9.806a4.05 4.05 0 0 0 3.975 4.039h9.933a4.01 4.01 0 0 0 3.975-4.039V5.96a4.05 4.05 0 0 0-3.975-4.037H5.96A4.007 4.007 0 0 0 1.985 5.96zm3.462 4.871a5.449 5.449 0 1 1 10.9 0 5.514 5.514 0 0 1-5.449 5.576 5.512 5.512 0 0 1-5.451-5.576zm1.923.065a3.57 3.57 0 0 0 3.523 3.589 3.529 3.529 0 0 0 3.526-3.585 3.525 3.525 0 1 0-7.049 0zM15.446 5a1.219 1.219 0 1 1 2.435 0 1.219 1.219 0 1 1-2.435 0z","transform":"translate(-11216.917 -12404.423)"}})])}}};

/***/ }),

/***/ "77hI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "79Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thanks_vue__ = __webpack_require__("sIyC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c366440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thanks_vue__ = __webpack_require__("51ZP");
function injectStyle (ssrContext) {
  __webpack_require__("c6fc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thanks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c366440_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thanks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "84ds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormClient_vue__ = __webpack_require__("fzFx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87bb32da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormClient_vue__ = __webpack_require__("N4oB");
function injectStyle (ssrContext) {
  __webpack_require__("GC1z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87bb32da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormClient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Sle":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arrowBack_vue__ = __webpack_require__("Xkyy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a6618e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrowBack_vue__ = __webpack_require__("KWA7");
function injectStyle (ssrContext) {
  __webpack_require__("sAd8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arrowBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a6618e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrowBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AYNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candidate-pos CandidatePosition.vue full-container yellowjob block"},[_c('div',{staticClass:"candidate__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goCandidateType}},[_c('arrowBack',{attrs:{"id":"arrow-back"}})],1),_vm._v(" "),_c('h1',{staticClass:"title-primary text-center animated fadeInDown delay1000ms"},[_vm._v("\n        Legal "),_c('span',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.guestName)+"!")]),_vm._v(" "),_c('br'),_vm._v("\n        Nos fala mais sobre você:\n      ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"choice-list animated fadeInUp delay1000ms"},[_c('div',{staticClass:"valid-checks",class:{'animated hide-to-left': _vm.candidatePosition==='unknown'},staticStyle:{"overflow":"hidden"}},_vm._l((_vm.positionList),function(position){return _c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidatePosition),expression:"candidatePosition"}],staticClass:"form-check-input",attrs:{"type":"radio"},domProps:{"value":position,"checked":_vm._q(_vm.candidatePosition,position)},on:{"change":function($event){_vm.candidatePosition=position}}}),_vm._v(" "),_c('span'),_vm._v("\n                "+_vm._s(position)+"\n              ")])])])}),0),_vm._v(" "),_c('div',{staticClass:"form-check",class:{'move-to-top': _vm.isUnknownPosition()}},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidatePosition),expression:"candidatePosition"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"unknown"},domProps:{"checked":_vm._q(_vm.candidatePosition,"unknown")},on:{"change":function($event){_vm.candidatePosition="unknown"}}}),_vm._v(" "),_c('span'),_vm._v("\n              Não sou nada disso, mas tenho certeza que serei muito útil à Bold.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"input-container"},[(_vm.isUnknownPosition())?_c('div',{staticClass:"form-group unknown-position animated fadeIn delay500ms fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.candidatePositionCustom),expression:"candidatePositionCustom"}],staticClass:"bold-control",attrs:{"id":"msg","type":"text","placeholder":"Então nos fala como...","maxlength":"50"},domProps:{"value":(_vm.candidatePositionCustom)},on:{"keyup":_vm.enterKeyPressed,"input":function($event){if($event.target.composing){ return; }_vm.candidatePositionCustom=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"msg"}},[_vm._v("Mensagem")])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUnknownPosition()),expression:"isUnknownPosition()"}],staticClass:"btn btn-bold btn-lg animated fadeIn delay500ms",on:{"click":function($event){return _vm.validateCandidatePosition()}}},[_vm._v("OK "),_c('i',{staticClass:"arrow simple"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"bold-logo",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1118.9 274.4"}},[_c('path',{staticClass:"st1",attrs:{"d":"M576.2 122.5c-8-8-17.4-14.3-28-18.9-21.5-9.2-47.5-9.2-69 0-10.6 4.5-20 10.9-28 18.9-8 8-14.4 17.4-18.9 28-4.6 10.7-6.9 22.3-6.9 34.5s2.3 23.8 6.9 34.5c4.5 10.6 10.9 20 18.9 28 8 8 17.4 14.4 28 18.9 10.7 4.6 22.3 6.9 34.5 6.9s23.8-2.3 34.5-6.9c10.6-4.5 20-10.9 28-18.9 8-8 14.3-17.4 18.9-28 4.6-10.7 6.9-22.3 6.9-34.5s-2.3-23.7-6.9-34.5c-4.6-10.6-10.9-20-18.9-28zM542.1 185c0 4-.7 7.6-2.2 11-1.5 3.6-3.5 6.6-6.1 9.2-2.6 2.6-5.6 4.6-9.1 6.1-6.9 2.9-15 2.9-21.9 0-3.5-1.5-6.5-3.5-9.1-6.1-2.6-2.6-4.7-5.7-6.3-9.3-1.5-3.4-2.2-7-2.2-10.8 0-3.9.7-7.4 2.2-10.8 1.6-3.6 3.7-6.7 6.3-9.4 2.6-2.6 5.6-4.6 9.1-6.1s7-2.2 11-2.2c3.9 0 7.5.7 10.9 2.2 3.5 1.5 6.5 3.5 9.1 6.1 2.6 2.6 4.6 5.6 6.1 9.2 1.5 3.4 2.2 7 2.2 10.9z","id":"letter-o"}}),_c('path',{staticClass:"st1",attrs:{"d":"M629.2.5H689v271.4h-59.8z","id":"letter-l"}}),_c('path',{staticClass:"st1",attrs:{"d":"M832.9 0v101.7c-19.8-6.9-43.5-6.1-63 2.2-10.6 4.5-20 10.9-28 18.9-8 8-14.4 17.4-18.9 28-4.6 10.7-6.9 22.3-6.9 34.5s2.3 23.8 6.9 34.5c4.5 10.6 10.9 20 18.9 28 8 8 17.4 14.4 28 18.9 10.7 4.6 22.3 6.9 34.5 6.9s23.8-2.3 34.5-6.9c10.6-4.5 20-10.9 28-18.9 8-8 14.3-17.4 18.9-28 4.6-10.7 6.9-22.3 6.9-34.5V0h-59.8zm0 185.3c0 4-.7 7.6-2.2 11-1.5 3.6-3.5 6.6-6.1 9.2-2.6 2.6-5.6 4.6-9.1 6.1-6.9 2.9-15 2.9-21.9 0-3.5-1.5-6.5-3.5-9.1-6.1-2.6-2.7-4.7-5.7-6.3-9.4-1.5-3.4-2.2-7-2.2-10.8 0-3.9.7-7.4 2.2-10.8 1.6-3.6 3.7-6.7 6.3-9.4 2.6-2.6 5.6-4.6 9.1-6.1s7-2.2 11-2.2c3.9 0 7.5.7 10.9 2.2 3.5 1.5 6.5 3.5 9.1 6.1 2.6 2.6 4.6 5.6 6.1 9.1 1.5 3.4 2.2 6.9 2.2 11.1z","id":"letter-d"}}),_c('path',{staticClass:"mask-b",attrs:{"d":"M192.1 0H415v275H192.1z","xmlns":"http://www.w3.org/2000/svg","id":"mascara"}}),_c('path',{staticClass:"st1",attrs:{"d":"M376.7 122.8c-8-8-17.4-14.3-28-18.9-19.6-8.3-43.1-9.1-63.2-2.2L285.7 0h-59.9v185.3c0 12.2 2.3 23.8 6.9 34.5 4.5 10.6 10.9 20 18.9 28 8 8 17.4 14.4 28 18.9 10.7 4.6 22.3 6.9 34.5 6.9s23.8-2.3 34.5-6.9c10.6-4.5 20-10.9 28-18.9 8-8 14.3-17.4 18.9-28 4.6-10.7 6.9-22.3 6.9-34.5s-2.3-23.7-6.9-34.5c-4.5-10.6-10.8-20-18.8-28zm-34.1 62.5c0 4-.7 7.6-2.2 11-1.5 3.6-3.5 6.6-6.1 9.2-2.6 2.6-5.6 4.6-9.1 6.1-6.9 2.9-15 2.9-21.9 0-3.5-1.5-6.5-3.5-9.1-6.1-2.6-2.7-4.7-5.7-6.3-9.4-1.5-3.4-2.2-7-2.2-11.1 0-3.8.7-7.3 2.2-10.6 1.6-3.6 3.7-6.6 6.4-9.3 2.6-2.6 5.6-4.6 9.1-6.1s7-2.2 11-2.2c3.9 0 7.5.7 10.9 2.2 3.5 1.5 6.5 3.5 9.1 6.1 2.6 2.6 4.6 5.6 6.1 9.2 1.4 3.4 2.1 7.1 2.1 11z","id":"letter-b"}}),_c('path',{staticClass:"st0",attrs:{"d":"M113.8 273.4L0 159.6 113.8 45.8l43.6 43.7-70.1 70.1 70.1 70.1z","id":"seta-1"}}),_c('path',{staticClass:"st0",attrs:{"d":"M1004.8 274.4l-43.7-43.8 70.2-70.2-70.2-70.3 43.7-43.7 114.1 114z","id":"seta-2"}})])}}};

/***/ }),

/***/ "B4ra":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BU9R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CFEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-stage BusinessStage.vue yellowjob"},[_c('div',{staticClass:"content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goBack()}}},[_c('arrowBack')],1),_vm._v(" "),_c('h1',{staticClass:"title-primary animated fadeInDown delay1000ms"},[_vm._v("\n      Queremos te conhecer um pouco melhor, "),_c('span',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.guestName)+"!")])]),_vm._v(" "),_c('div',{staticClass:"choice-list animated fadeInDown delay1000ms"},[_vm._l((_vm.stageList),function(item){return _c('div',{staticClass:"form-check"},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessState),expression:"businessState"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"businessState"},domProps:{"value":item,"checked":_vm._q(_vm.businessState,item)},on:{"change":function($event){_vm.businessState=item}}}),_vm._v(" "),_c('span'),_vm._v("\n            "+_vm._s(item)+"\n          ")])])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DrGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bold_vue__ = __webpack_require__("iNzD");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb13655_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bold_vue__ = __webpack_require__("N+9N");
function injectStyle (ssrContext) {
  __webpack_require__("jvYG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eb13655"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bold_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb13655_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bold_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snapsvg__ = __webpack_require__("o8uS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snapsvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_snapsvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkMark_vue__ = __webpack_require__("qPpN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  import MainMenu from './MainMenu.vue'





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      salutation: this.getSalutation(),
      name: ''
    };
  },

  computed: {
    count: function count() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.count;
    },
    guestName: function guestName() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.guestName;
    }
  },

  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);
    // document.querySelector('title').innerText = '<bold>';

    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'minimal');

    var arrowLeft = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()(".home #seta-1");
    var arrowRight = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()(".home #seta-2");
    var maskB = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()('.home #mascara');

    var letterB = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()('.home #letter-b');
    var letterO = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()('.home #letter-o');
    var letterL = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()('.home #letter-l');
    var letterD = __WEBPACK_IMPORTED_MODULE_1_snapsvg___default()('.home #letter-d');

    // remove from view
    letterO.transform('t50');
    letterL.transform('t-160');
    letterD.transform('t-250');

    // set initial positions
    maskB.transform('t250');
    letterB.transform('t250');
    arrowRight.transform('t-280');
    arrowLeft.transform('t280');

    var animationSpeed = 400;

    setTimeout(function () {
      // arrows
      arrowRight.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
      arrowLeft.animate({ transform: 't0' }, animationSpeed, mina.easeinout);

      maskB.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
      letterB.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
      letterO.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
      letterL.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
      letterD.animate({ transform: 't0' }, animationSpeed, mina.easeinout);
    }, 1000);
  },

  components: {
    logo: __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default.a,
    checkMark: __WEBPACK_IMPORTED_MODULE_3__checkMark_vue__["a" /* default */]
  },
  methods: {
    /**
     * Retorna a mss de boa vindas de acordo com a hora do dia
     * @returns {string}
     */
    guestEnter: function guestEnter() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setGuestName', '');
      this.$router.push('guest');
    },
    getSalutation: function getSalutation() {
      var msg = 'Boa noite';
      var currentHour = new Date().getHours();
      if (currentHour >= 5 && currentHour < 12) {
        msg = 'Bom dia';
      } else if (currentHour >= 12 && currentHour < 18) {
        msg = 'Boa tarde';
      }
      return msg;
    },
    setGuestName: function setGuestName() {
      var name = this.name.replace(/ /g, '');
      if (!name) {
        alert('Entre com seu nome!');
        this.name = '';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setGuestName', this.name);
      this.$router.push('guest');
    },
    enterKeyPressed: function enterKeyPressed(event) {
      if (event.keyCode === 13) {
        this.setGuestName();
      }
    }
  }
});

/***/ }),

/***/ "GC1z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GOfw":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-14750.013 -9747.465 32.869 18.652","width":"32","height":"18"}},[_c('defs'),_c('g',{attrs:{"id":"continuar","transform":"translate(-15963 -11605)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_47","data-name":"Path 47","d":"M1.4 23.407h30.041","transform":"rotate(180 622.214 945.134)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_48","data-name":"Path 48","d":"M9.312 23.024L1.4 15.112 9.312 7.2","transform":"rotate(180 622.214 940.986)"}})])])}}};

/***/ }),

/***/ "IQRm":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"ico-close",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"50","height":"50"}},[_c('circle',{staticClass:"st0",attrs:{"cx":"25","cy":"25","r":"25","id":"bg"}}),_c('path',{staticClass:"st1",attrs:{"d":"M36.3 15.1l-1.4-1.4-9.9 9.9-9.9-9.9-1.4 1.4 9.9 9.9-9.9 9.9 1.4 1.4 9.9-9.9 9.9 9.9 1.4-1.4-9.9-9.9z","id":"x"}})])}}};

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    debug: false,

    menuClass: '',
    guestName: '',
    guestType: '',
    candidate: {
      type: '',
      position: ''
    },
    client: {
      contactType: '',
      businessState: '',
      interests: ''
    }
  },
  mutations: {
    increment: function increment(state) {
      state.count++;
    },
    setMenuClass: function setMenuClass(state, className) {
      state.menuClass = className;
    },
    setGuestName: function setGuestName(state, name) {
      state.guestName = name;
    },

    /**
     * Ste the gest type (candidate|client)
     * @param state
     * @param type
     */
    setGuestType: function setGuestType(state, type) {
      state.guestType = type;
    },
    setCandidateType: function setCandidateType(state, val) {
      state.candidate.type = val;
    },
    setCandidatePosition: function setCandidatePosition(state, val) {
      state.candidate.position = val;
    },
    setBusinessStage: function setBusinessStage(state, val) {
      state.client.businessState = val;
    },
    setBusinessInterests: function setBusinessInterests(state, val) {
      state.client.interests = val;
    }
  },
  getters: {
    guestFirstName: function guestFirstName(state) {
      return state.guestName.split(' ')[0];
    },
    getMenuClass: function getMenuClass(state) {
      return 'menu MainMenu.vue ' + state.menuClass;
    }
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
}));

/***/ }),

/***/ "K04W":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"ico-face",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-11439 -12423 10.703 22.882","width":"11","height":"23"}},[_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Union_2","data-name":"Union 2","d":"M2.307 22.882V12.241H0V7.627h2.307V4.614C2.307 4.037 2.179 0 7.18 0h3.52v4.551H7.627a.679.679 0 0 0-.768.768v2.308H10.7l-.768 4.614H6.859v10.641z","transform":"translate(-11439 -12423)"}})])}}};

/***/ }),

/***/ "KWA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('arrowBackIcon',{attrs:{"id":"arrow-back"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L22p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash Spash.vue",attrs:{"id":"scene1"}},[_c('div',{staticClass:"splash__grid",class:{'hidden':_vm.isAnimationDisabled}}),_vm._v(" "),_c('div',{staticClass:"splash__challenge"},[_c('div',{staticClass:"switch",class:{'warn': _vm.showWarningRipple && _vm.isAnimationDisabled}},[_c('div',{staticClass:"warn__text"},[_vm._v("Desafie sua mente antes de entrar no site")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('a',{staticClass:"splash__link-next",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goToSite()}}},[_c('span',[_vm._v("Entre no site")]),_vm._v(" "),_c('i',{staticClass:"arrow"})])]),_vm._v(" "),_c('logo',{staticClass:"splash__logo"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Dare")]),_vm._v(" "),_c('span',[_vm._v("Your")]),_vm._v(" "),_c('span',[_vm._v("Mind")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d989334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("jVZ3");
function injectStyle (ssrContext) {
  __webpack_require__("MsAq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d989334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__("t+Rb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_media_ico_close_svg__ = __webpack_require__("IQRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_media_ico_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_media_ico_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_media_ico_map_svg__ = __webpack_require__("pd/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_media_ico_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_media_ico_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_facebook_svg__ = __webpack_require__("K04W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_media_ico_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_media_ico_instagram_svg__ = __webpack_require__("5XGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_media_ico_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_media_ico_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_media_ico_youtube_svg__ = __webpack_require__("XB5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_media_ico_youtube_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_media_ico_youtube_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactForm',
  data: function data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      select: {
        isOpen: false,
        value: 'Como posso ajudar?',
        choices: ['Tenho uma empresa e quero melhorar meus resultados', 'Sou um profissional/estudante e quero trabalhar na bold']
      }
    };
  },
  mounted: function mounted() {
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'hidden');

    var $this = this;
    $('.phone').mask('00 0000.00009', {
      onChange: function onChange(val) {
        $this.form.phone = val;
      }
    });
  },

  components: {
    logo: __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default.a,
    closeButton: __WEBPACK_IMPORTED_MODULE_2__static_media_ico_close_svg___default.a,
    mapPin: __WEBPACK_IMPORTED_MODULE_3__static_media_ico_map_svg___default.a,
    icoFace: __WEBPACK_IMPORTED_MODULE_4__static_media_ico_facebook_svg___default.a,
    icoInsta: __WEBPACK_IMPORTED_MODULE_5__static_media_ico_instagram_svg___default.a,
    icoYoutube: __WEBPACK_IMPORTED_MODULE_6__static_media_ico_youtube_svg___default.a
  },
  methods: {
    goToHome: function goToHome() {
      this.$router.push('/home');
    },
    goBack: function goBack() {
      this.log('closing');
      this.$router.go(-1);
    },
    resizeTextarea: function resizeTextarea(event) {
      var el = event.target;
      setTimeout(function () {
        el.style.cssText = 'height:auto;';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
      }, 0);
    },
    toggleFakeSelect: function toggleFakeSelect() {
      this.select.isOpen = !this.select.isOpen;
    },
    setSelectValue: function setSelectValue(val) {
      this.select.value = val;
      this.select.isOpen = false;
    },
    chekEmptyField: function chekEmptyField(event) {
      var el = $(event.target);
      if (el.val().length > 0) {
        el.parent().addClass('white');
      } else {
        el.parent().removeClass('white');
      }
    },
    submitForm: function submitForm(event) {
      event.preventDefault();

      var $this = this;
      event.preventDefault();
      window.scroll(0, 0);

      var postData = [{ name: 'identificador', value: 'contato_rapido' }, { name: 'tok' + 'en_rds' + 'tation', value: '76d813f385092cd1' + 'c7a5e954a4c73c5e' }, { name: 'nome', value: this.form.name }, { name: 'telefone', value: this.form.phone }, { name: 'email', value: this.form.email }, { name: 'como-posso-ajudar', value: this.select.value }, { name: 'mensagem', value: this.form.message }];

      $('.loading').removeClass('hideL');

      RdIntegration.post(postData, function () {
        $this.$router.push('/thanks');
      });

      return false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "MsAq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated slideInLeft","leave-active-class":"animated slideOutLeft"}},[_c('div',{staticClass:"hello Bold.vue"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://chat.vuejs.org","target":"_blank"}},[_vm._v("Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank"}},[_vm._v("Docs for This Template")])])]),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank"}},[_vm._v("awesome-vue")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N4oB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-client FormClient.vue full-container block"},[_c('div',{staticClass:"form__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goBack}},[_c('arrowBack',{attrs:{"id":"arrow-back"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"text-second animated fadeInDown delay1000ms"},[_vm._v("\n        Mas antes, precisamos de algumas informações para que possamos te conhecer melhor:\n      ")]),_vm._v(" "),_c('form',{on:{"submit":_vm.goToThanksPage}},[_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Nome","maxlength":"50","autocomplete":"both","required":""},domProps:{"value":(_vm.form.name)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Nome")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"bold-control",attrs:{"type":"email","placeholder":"E-mail","maxlength":"50","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.email)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("E-mail")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control phone",attrs:{"pattern":"[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?","type":"text","placeholder":"00 0000.00000","maxlength":"13","required":"","autocomplete":"both"},on:{"keyup":_vm.chekEmptyField,"blur":_vm.chekEmptyField}}),_vm._v(" "),_c('label',[_vm._v("Telefone")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.company),expression:"form.company"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Nome da sua empresa","maxlength":"50","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.company)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "company", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Nome da sua empresa")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cargo),expression:"form.cargo"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Cargo","maxlength":"40","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.cargo)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cargo", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Cargo")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.como_podemos_ajudar),expression:"form.como_podemos_ajudar"}],staticClass:"bold-control",class:{'active': _vm.form.como_podemos_ajudar},attrs:{"name":"como_podemos_ajudar","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "como_podemos_ajudar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Como podemos te ajudar?")]),_vm._v(" "),_c('option',[_vm._v("Quero fazer o um site/ecommerce")]),_vm._v(" "),_c('option',[_vm._v("Quero fazer marketing digital")]),_vm._v(" "),_c('option',[_vm._v("Outros")])]),_vm._v(" "),_c('label',[_vm._v("Como podemos te ajudar?")])]),_vm._v(" "),(_vm.form.como_podemos_ajudar === 'Quero fazer marketing digital')?_c('div',{staticClass:"form-group checklist"},[_c('h5',[_vm._v("Qual seu objetivo em contratar a Bold?")]),_vm._v(" "),_vm._l((_vm.objetivos),function(value,key){return _c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivos[key]),expression:"objetivos[key]"}],staticClass:"form-check-input bold-control",attrs:{"type":"checkbox","id":'seg'+key,"name":"interesse","required":!_vm.objetivosValidos},domProps:{"value":value,"checked":Array.isArray(_vm.objetivos[key])?_vm._i(_vm.objetivos[key],value)>-1:(_vm.objetivos[key])},on:{"change":function($event){var $$a=_vm.objetivos[key],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.objetivos, key, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.objetivos, key, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.objetivos, key, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'seg'+key}},[_vm._v(_vm._s(key))])])})],2):_vm._e(),_vm._v(" "),(_vm.form.como_podemos_ajudar && _vm.form.como_podemos_ajudar !== 'Quero fazer o um site/ecommerce')?_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.em_qual_segmento_a_sua_empresa_atua),expression:"form.em_qual_segmento_a_sua_empresa_atua"}],staticClass:"bold-control",class:{'active': _vm.form.em_qual_segmento_a_sua_empresa_atua},attrs:{"name":"como_podemos_ajudar","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "em_qual_segmento_a_sua_empresa_atua", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Qual seu segmento?")]),_vm._v(" "),_c('option',[_vm._v("Hospitalidade - Resort / Hotel / Pousada")]),_vm._v(" "),_c('option',[_vm._v("Clínicas - Saúde / Estética / Beleza")]),_vm._v(" "),_c('option',[_vm._v("Outros")])]),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Qual seu segmento?")])]):_vm._e(),_vm._v(" "),(_vm.form.em_qual_segmento_a_sua_empresa_atua === 'Hospitalidade - Resort / Hotel / Pousada')?_c('div',{staticClass:"hotel-wrapper"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.qual_seu_negocio_hotel),expression:"form.qual_seu_negocio_hotel"}],staticClass:"bold-control",class:{'active': _vm.form.qual_seu_negocio_hotel},attrs:{"name":"qual_seu_negocio_hotel","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "qual_seu_negocio_hotel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Qual tipo de hotel?")]),_vm._v(" "),_c('option',[_vm._v("Somos um Hotel")]),_vm._v(" "),_c('option',[_vm._v("Somos um Resort")]),_vm._v(" "),_c('option',[_vm._v("Somos uma Pousada")])]),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Qual tipo de hotel?")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quantidade_acomodacao),expression:"form.quantidade_acomodacao"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Número de acomodações","maxlength":"50","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.quantidade_acomodacao)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "quantidade_acomodacao", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Número de acomodações")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ticket_medio_por_reserva),expression:"form.ticket_medio_por_reserva"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Ticket médio por reserva","maxlength":"50","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.ticket_medio_por_reserva)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "ticket_medio_por_reserva", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Ticket médio por reserva")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quanto_investe_em_midia),expression:"form.quanto_investe_em_midia"}],staticClass:"bold-control",class:{'active': _vm.form.quanto_investe_em_midia},attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "quanto_investe_em_midia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Qual a verba de mídia?")]),_vm._v(" "),_c('option',[_vm._v("Não invisto, mas quero investir")]),_vm._v(" "),_c('option',[_vm._v("Entre R$1 mil e R$5 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$5 mil e R$10 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$10 mil e R$20 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$20 mil e R$30 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$30 mil e R$40 mil")]),_vm._v(" "),_c('option',[_vm._v("Acima de R$50 mil")])]),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Qual a verba de mídia?")])])]):_vm._e(),_vm._v(" "),(_vm.form.em_qual_segmento_a_sua_empresa_atua === 'Clínicas - Saúde / Estética / Beleza')?_c('div',{staticClass:"clinica-wrapper"},[_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.clinica_total_unidades),expression:"form.clinica_total_unidades"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Quantas unidades?","maxlength":"10","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.clinica_total_unidades)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "clinica_total_unidades", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Quantas unidades?")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quanto_investe_em_midia),expression:"form.quanto_investe_em_midia"}],staticClass:"bold-control",class:{'active': _vm.form.quanto_investe_em_midia},attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "quanto_investe_em_midia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Qual a verba de mídia?")]),_vm._v(" "),_c('option',[_vm._v("Não invisto, mas quero investir")]),_vm._v(" "),_c('option',[_vm._v("Entre R$1 mil e R$5 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$5 mil e R$10 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$10 mil e R$20 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$20 mil e R$30 mil")]),_vm._v(" "),_c('option',[_vm._v("Entre R$30 mil e R$40 mil")]),_vm._v(" "),_c('option',[_vm._v("Acima de R$50 mil")])]),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Qual a verba de mídia?")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.equipe_comercial_call_center_clinica),expression:"form.equipe_comercial_call_center_clinica"}],staticClass:"bold-control",class:{'active': _vm.form.equipe_comercial_call_center_clinica},attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "equipe_comercial_call_center_clinica", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Possui equipe comercial/call center?")]),_vm._v(" "),_c('option',[_vm._v("Sim, até 2 pessoas.")]),_vm._v(" "),_c('option',[_vm._v("Sim, entre 3 e 5 pessoas.")]),_vm._v(" "),_c('option',[_vm._v("Sim, mais de 5 pessoas.")]),_vm._v(" "),_c('option',[_vm._v("Não tenho equipe comercial.")])]),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Possui equipe comercial/call center?")])]),_vm._v(" "),_c('div',{staticClass:"form-group checklist"},[_c('h5',[_vm._v("Quais ferramentas você utiliza para potencializar suas vendas?")]),_vm._v(" "),_vm._l((_vm.ferramentas),function(value,key){return _c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ferramentas[key]),expression:"ferramentas[key]"}],staticClass:"form-check-input bold-control",attrs:{"type":"checkbox","id":'cal'+key,"name":"interesse","required":!_vm.ferramentasValidas},domProps:{"value":value,"checked":Array.isArray(_vm.ferramentas[key])?_vm._i(_vm.ferramentas[key],value)>-1:(_vm.ferramentas[key])},on:{"change":function($event){var $$a=_vm.ferramentas[key],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.ferramentas, key, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.ferramentas, key, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.ferramentas, key, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'cal'+key}},[_vm._v(_vm._s(key))])])})],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quantos_leads_por_mes_sua_empresa_gera),expression:"form.quantos_leads_por_mes_sua_empresa_gera"}],staticClass:"bold-control",class:{'active': _vm.form.quantos_leads_por_mes_sua_empresa_gera},attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "quantos_leads_por_mes_sua_empresa_gera", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Quantos leads geram por mês?")]),_vm._v(" "),_c('option',[_vm._v("Não sei informar")]),_vm._v(" "),_c('option',[_vm._v("Ainda não gero leads")]),_vm._v(" "),_c('option',[_vm._v("Até 50 leads")]),_vm._v(" "),_c('option',[_vm._v("Até 100 leads")]),_vm._v(" "),_c('option',[_vm._v("Até 300 leads")]),_vm._v(" "),_c('option',[_vm._v("Até 500 leads")]),_vm._v(" "),_c('option',[_vm._v("Até 1000 leads")]),_vm._v(" "),_c('option',[_vm._v("Mais de 1000 leads")])]),_vm._v(" "),_c('label',[_vm._v("Quantos leads geram por mês?")])])]):_vm._e(),_vm._v(" "),(_vm.form.em_qual_segmento_a_sua_empresa_atua === 'Outros')?_c('div',{staticClass:"outros-wrapper"},[_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.segmento_outro),expression:"form.segmento_outro"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Informe qual seu segmento","maxlength":"50","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.segmento_outro)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "segmento_outro", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Qual seu segmento?")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cargo),expression:"form.cargo"},{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Cargo","maxlength":"40","required":"","autocomplete":"both"},domProps:{"value":(_vm.form.cargo)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cargo", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Cargo")])])]):_vm._e(),_vm._v(" "),(_vm.form.em_qual_segmento_a_sua_empresa_atua || _vm.form.como_podemos_ajudar === 'Quero fazer o um site/ecommerce')?_c('div',{staticClass:"form-group fake-label textarea"},[_c('textarea',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.Mensagem),expression:"form.Mensagem"}],staticClass:"bold-control",attrs:{"placeholder":"Alguma outra informação que queira compartilhar?","minlength":"2","maxlength":"1024"},domProps:{"value":(_vm.form.Mensagem)},on:{"keyup":_vm.chekEmptyField,"keydown":_vm.resizeTextarea,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "Mensagem", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Alguma outra informação que queira compartilhar?")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-bold btn-lg btn-padding-lg",attrs:{"type":"submit"}},[_vm._v("enviar")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title-primary animated fadeInDown delay1000ms"},[_vm._v("Você está no caminho certo "),_c('span',{staticClass:"sub"},[_vm._v("!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vivus__ = __webpack_require__("Jn6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vivus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vivus__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

window.debug = true;

/**
 * Log helper
 * @param val
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.log = function (val) {
  if (window.debug) {
    console.log(val);
  }
};

// helper para inputs com placeholder flutuante
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('fakelabel', {
  inserted: function inserted(el) {
    el.onfocus = function (event) {
      el.parentNode.classList.add('focus');
    };
    el.onblur = function (event) {
      el.parentNode.classList.remove('focus');

      if (el.value && el.value.length > 0) {
        el.classList.add('dirty');
      } else {
        el.classList.remove('dirty');
      }
    };

    var event = new Event('blur');
    el.dispatchEvent(event);
  }
});

// helper para inputs com placeholder flutuante
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('magicheck', {
  inserted: function inserted(el) {
    var anim = new __WEBPACK_IMPORTED_MODULE_5_vivus___default.a(el, {
      start: 'manual', // avoid memory leak on scroll event
      duration: 5,
      animTimingFunction: __WEBPACK_IMPORTED_MODULE_5_vivus___default.a.EASE_IN
    });
    anim.reset().stop();
    $(el).bind('drawsvg', function () {
      anim.reset().stop().play();
    });
  }
});

// Vue.directive('parentfocusclass', {
//   inserted: function (el) {
//     el.onfocus = (event) => {
//       el.parentNode.classList.add('focus');
//     };
//     el.onblur = (event) => {
//       el.parentNode.classList.remove('focus');
//     };
//   }
// });


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  // template: '<App/>',
  template: '<router-view/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "O7oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview Overview.vue full-container"},[_c('div',{staticClass:"overview__content w100"},[_c('div',{staticClass:"section1 h100"},[_c('div',{staticClass:"section__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goBack}},[_c('arrowBack',{staticClass:"inverted"})],1),_vm._v(" "),_c('h1',{staticClass:"title-primary text-center animated fadeInDown delay1000ms"},[_vm._v("\n          Maravilha "),_c('span',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.guestName)+"!")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('h2',{staticClass:"title-primary text-inverted animated fadeInDown delay1000ms"},[_vm._v("\n          Nossa cultura empresarial é absolutamente focada em resultados.\n        ")]),_vm._v(" "),_c('div',{staticClass:"abs animated fadeInDown delay1000ms"},[_c('div',{staticClass:"ctn",on:{"click":function($event){return _vm.goTo('.section2')}}},[_c('div',{staticClass:"scroll-down"})])])])]),_vm._v(" "),_c('div',{staticClass:"section2 h100 hidden"},[_c('div',{staticClass:"video__ctn h100"},[_c('video',{attrs:{"id":"bgvid","playsinline":"","preload":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/video3.mp4","type":"video/mp4"}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"section3 hidden"},[_c('div',{staticClass:"section__content"},[_c('h2',{staticClass:"title-primary"},[_vm._v("Veja quem confia suas estratégias de marketing e comunicação à Bold:")]),_vm._v(" "),_c('div',{staticClass:"overview__brands"},[_c('ul',_vm._l((_vm.parceiros),function(n,index){return _c('li',{key:n,class:{'paria': index > 27}},[_c('img',{attrs:{"data-aos":"fade-down","data-aos-offset":"150","data-aos-once":"true","src":'/static/media/partners/@2x/'+n+'@2x.png',"alt":"Client"}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"section4 hidden"},[_c('h1',{staticClass:"title-primary"},[_c('logoMinimal'),_vm._v(" "),_c('span',{staticStyle:{"color":"#fff"}},[_vm._v("Equipe")]),_vm._v(" "),_c('logoCoda',{attrs:{"fill":"#ffffff"}})],1),_vm._v(" "),(false)?_c('div',{staticClass:"bosses"},[_vm._l((_vm.bosses),function(item){return _c('div',{key:item,staticClass:"human hero"},[_c('img',{attrs:{"src":"/static/media/placeholder-human.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.nome))])]),_vm._v(" "),_c('div',{staticClass:"role"},[_vm._v("Diretor")])]),_vm._v(" "),_c('div',{staticClass:"sprite"},[_c('img',{attrs:{"alt":"","onerror":"this.src=\"/static/media/people/placeholder-sprite.jpg\"","src":'/static/media/people/'+item.slug+'.png'}})])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"staff"},[_vm._l((_vm.orderedStaff),function(ref,index){
var nome = ref.nome;
var snome = ref.snome;
var pos = ref.pos;
return _c('div',{key:_vm.filePath(index),staticClass:"hero",class:{'paria': _vm.isParia(index)},attrs:{"data-aos":"fade-in","data-aos-offset":50,"data-aos-once":"false"}},[_c('img',{attrs:{"src":"/static/media/placeholder-hero.png","alt":"Hero"}}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(nome))]),_c('span',[_vm._v(_vm._s(snome))]),_vm._v(" "),_c('div',{staticClass:"role"},[_vm._v(_vm._s(pos))])])]),_vm._v(" "),_c('div',{staticClass:"sprite"},[_c('img',{attrs:{"onerror":"this.src=\"/static/media/people/placeholder-sprite.jpg\"","src":_vm.filePath(index),"alt":snome}})])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2),_vm._v(" "),_c('div',{staticClass:"bottom-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goBack}},[_c('arrowBack',{}),_vm._v(" "),_c('span',[_vm._v("voltar")])],1)]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goToClientStage}},[_c('span',[_vm._v("continuar")]),_vm._v(" "),_c('arrow')],1)])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section__content"},[_c('div',{staticClass:"left h100",attrs:{"data-aos":"fade","data-aos-offset":"500"}},[_c('div',{staticClass:"text-second"},[_c('div',{staticClass:"padding"},[_vm._v("\n              Acreditamos que a comunicação é um instrumento poderoso para resolver problemas de vendas, de imagem, de\n              gestão e de motivação. Além disso, aqui na "),_c('span',[_vm._v("Bold")]),_vm._v(", levamos criatividade à sério. Com boas\n              ideias e objetivos claros, o retorno sobre o investimento é só uma questão de tempo.\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ODYY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OrSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__ = __webpack_require__("8Sle");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkboxSwitcher_vue__ = __webpack_require__("5Spv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_checkbox_svg__ = __webpack_require__("kk2J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_checkbox_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_checkbox_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_arrow_right_svg__ = __webpack_require__("cXxo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_arrow_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel__ = __webpack_require__("gqkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cart',
  data: function data() {
    return {
      form: {}
    };
  },

  components: {
    checkMate: __WEBPACK_IMPORTED_MODULE_2__assets_checkbox_svg___default.a,
    arrowBack: __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__["a" /* default */],
    slideArrow: __WEBPACK_IMPORTED_MODULE_3__assets_arrow_right_svg___default.a,
    checkboxSwitcher: __WEBPACK_IMPORTED_MODULE_1__checkboxSwitcher_vue__["a" /* default */]
  },
  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    }
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', '');

    var isMobileWidth = window.outerWidth < 767;
    var totalSlides = 4;

    if (isMobileWidth) {
      return;
    }

    var video = document.querySelector('.cart video');
    video.currentTime = 0;
    setTimeout(function () {
      video.play();
    }, 1000);

    setTimeout(function () {
      $('.cart .categories').slick({
        arrows: false,
        infinite: false,
        fade: true
      });
    }, 200);
  },
  beforeDestroy: function beforeDestroy() {
    $('.phone').unmask();
    try {
      //        $('.content .items').slick('unslick');
    } catch (e) {}
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    toggleCheck: function toggleCheck() {
      if ($('.switch__container input:checked').length > 0) {
        $('.btn-fixed').removeClass('hidden');
      } else {
        $('.btn-fixed').addClass('hidden');
      }
    },
    goToForm: function goToForm(event) {
      event.preventDefault();
      if ($('.switch__container input:checked').length < 1) {
        alert('Selecione pelo menos uma das opções exibidas!');
        return false;
      }

      var interestList = $('.switch__container input:checked').map(function () {
        return $(this).val().replace(/\r?\n|\r/, '');
      }).toArray().join(',');

      this.$store.commit('setBusinessInterests', interestList);
      this.$router.push('/client/contact');
      return false;
    },
    resizeTextarea: function resizeTextarea(event) {
      var el = event.target;
      setTimeout(function () {
        el.style.cssText = 'height:auto;';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
      }, 0);
    },
    chekEmptyField: function chekEmptyField(event) {
      var el = $(event.target);
      if (el.val().length > 0) {
        el.parent().addClass('white');
      } else {
        el.parent().removeClass('white');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "PqxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404 404.vue yellowjob"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"sauron"},[_c('icon404'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"help"},[_c('h1',[_vm._v("oxe!")]),_vm._v("\n      Não encontramos a sua página, mas "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.goHome()}}},[_vm._v("clique aqui")]),_vm._v(" pra voltar para home\n\n\n      "),_c('a',{staticClass:"go-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goHome()}}},[_c('arrowBack')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buld"},[_c('div',{staticClass:"limit"},[_c('div',{staticClass:"iris"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PvVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home Home.vue"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"home__logo"},[_c('logo')],1),_vm._v(" "),_c('div',{staticClass:"line1 animated fadeInDown"},[_vm._v(_vm._s(_vm.salutation)+"!")]),_vm._v(" "),_c('div',{staticClass:"line2 animated fadeInDown"},[_vm._v("Qual seu nome?")]),_vm._v(" "),_c('div',{staticClass:"input-block fake-label animated fadeInDown"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"id":"name","type":"text","placeholder":"Nome"},domProps:{"value":(_vm.name)},on:{"keyup":_vm.enterKeyPressed,"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Nome")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-bold animated fadeIn",on:{"click":function($event){return _vm.setGuestName()}}},[_vm._v("OK "),_c('i',{staticClass:"arrow simple"})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-bold btn-guest animated fadeIn",on:{"click":_vm.guestEnter}},[_vm._v("Não quero informar meu nome "),_c('i',{staticClass:"arrow simple"})]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"company"},[_c('span',{staticClass:"f-partners text-center"},[_c('a',{attrs:{"href":"https://www.kommo.com/","target":"_blank"}},[_c('img',{attrs:{"width":"100","height":"44","src":"/static/kommo.svg","alt":"Kommo"}})])]),_vm._v(" "),_vm._v("\n    H&T DESENVOLVIMENTO WEB LTDA - ME CNPJ: 18.106.092/0001-54 Rua Dona Magina Pontual, 384, Boa Viagem - Recife - PE CEP: 51.021-510\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidatePosition_vue__ = __webpack_require__("RmBo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab423a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidatePosition_vue__ = __webpack_require__("AYNU");
function injectStyle (ssrContext) {
  __webpack_require__("naL6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidatePosition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab423a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidatePosition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RH2U":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"logo-minimal",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-17263 -13007 79.738 35.512","width":"79","height":"35"}},[_c('defs'),_c('g',{attrs:{"id":"logo","transform":"translate(-17263 -13007.1)"}},[_c('g',{attrs:{"id":"Group_17","data-name":"Group 17","transform":"translate(0 5.964)"}},[_c('path',{staticClass:"cls-1 arrow_left",attrs:{"id":"Path_7","data-name":"Path 7","d":"M14.742 36.866L0 22.042 14.742 7.3l5.7 5.7-9.122 9.041 9.122 9.122z","transform":"translate(0 -7.3)"}})]),_c('g',{attrs:{"id":"Group_18","data-name":"Group 18","transform":"translate(59.295 6.046)"}},[_c('path',{staticClass:"cls-1 arrow_right",attrs:{"id":"Path_8","data-name":"Path 8","d":"M78.42 36.966l-5.62-5.7 9.122-9.041L72.8 13.1l5.62-5.7 14.824 14.824z","transform":"translate(-72.8 -7.4)"}})]),_c('g',{attrs:{"id":"Group_20","data-name":"Group 20","transform":"translate(29.322 .1)"}},[_c('g',{attrs:{"id":"Group_19","data-name":"Group 19"}},[_c('path',{staticClass:"cls-2 letter_b",attrs:{"id":"Path_9","data-name":"Path 9","d":"M55.548 15.982a11.123 11.123 0 0 0-3.665-2.443 11.462 11.462 0 0 0-8.226-.244V.1H36v24.027a11.881 11.881 0 0 0 .9 4.48 11.231 11.231 0 0 0 6.1 6.109 11.647 11.647 0 0 0 8.959 0 11.231 11.231 0 0 0 6.109-6.109 11.881 11.881 0 0 0 .9-4.48 10.931 10.931 0 0 0-.977-4.561 10.022 10.022 0 0 0-2.443-3.584zm-4.4 8.063a4.612 4.612 0 0 1-.244 1.466 4.01 4.01 0 0 1-.815 1.222 4.565 4.565 0 0 1-1.222.814 3.479 3.479 0 0 1-2.851 0 4.01 4.01 0 0 1-1.222-.814 3.222 3.222 0 0 1-.814-1.222 3.89 3.89 0 0 1-.326-1.466 3.8 3.8 0 0 1 .244-1.385 3.744 3.744 0 0 1 2.036-2.036 4.137 4.137 0 0 1 1.385-.244 3.8 3.8 0 0 1 1.385.244 4.01 4.01 0 0 1 1.222.814 4.565 4.565 0 0 1 .814 1.222 2.132 2.132 0 0 1 .409 1.386z","transform":"translate(-36 -.1)"}})])])])])}}};

/***/ }),

/***/ "Re2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candidate CandidateType.vue full-container",on:{"click":_vm.autoCloseSelect}},[_c('div',{staticClass:"candidate__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goBack()}}},[_c('arrowBack')],1),_vm._v(" "),_c('h1',{staticClass:"title-primary text-center animated fadeInDown delay1000ms"},[_vm._v("\n        Show de bola "),_c('span',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.guestName)+"!")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"colm animated fadeInDown delay1500ms"},[_c('div',{staticClass:"candidate__selector"},[_c('div',{staticClass:"fake-selector",class:{'open': _vm.select.isOpen}},[_c('div',{staticClass:"current",on:{"click":_vm.toggleFakeSelect}},[_vm._v("\n              "+_vm._s(_vm.select.value)+"\n              "),_c('i',{staticClass:"arrow simple down"})]),_vm._v(" "),_c('div',{staticClass:"escolhas animated zoomIn"},_vm._l((_vm.select.choices),function(item){return _c('span',{class:{'selected': _vm.select.value === item},on:{"click":function($event){return _vm.setSelectValue(item)}}},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-bold btn-lg",on:{"click":_vm.goToCandidatePosition}},[_vm._v("OK "),_c('i',{staticClass:"arrow simple"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colm animated fadeInDown delay1500ms"},[_c('div',{staticClass:"candidate__text text-second"},[_vm._v("\n          Pessoas competentes são nosso principal ativo. E se você é um bom profissional e tem potencial, temos muito interesse em te conhecer melhor\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RmBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__ = __webpack_require__("8Sle");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CandidatePosition',
  data: function data() {
    return {
      candidatePosition: '',
      candidatePositionCustom: '',
      positionList: ['Sou administrativo/financeiro', 'Sou atendimento', 'Sou mídia off-line', 'Sou mídia online', 'Sou produtor gráfico e eletrônico', 'Sou diretor de arte', 'Sou redator', 'Sou videomaker', 'Sou webdesigner', 'Sou desenvolvedor front-end', 'Sou desenvolvedor back-end']
    };
  },

  components: {
    MainMenu: __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__["a" /* default */],
    arrowBack: __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__["a" /* default */]
  },
  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    }
  },
  mounted: function mounted() {
    this.log('mounted comp: ' + this.$options.name);
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');
  },

  watch: {
    candidatePosition: function candidatePosition(newVal, oldVal) {
      if (newVal && newVal !== 'unknown') {
        this.setCandidatePosition(newVal);
      }
    }
  },
  methods: {
    goCandidateType: function goCandidateType() {
      this.$router.go(-1);
    },
    isUnknownPosition: function isUnknownPosition() {
      return this.candidatePosition === 'unknown';
    },
    validateCandidatePosition: function validateCandidatePosition() {
      var position = this.candidatePositionCustom.replace(/ /g, '');
      if (!position) {
        alert('O campo mensagem é obrigatório!');
        this.candidatePositionCustom = '';
        return;
      }
      this.setCandidatePosition(this.candidatePositionCustom);
    },
    setCandidatePosition: function setCandidatePosition(position) {
      this.$store.commit('setCandidatePosition', position);
      window.scroll(0, 0);
      this.$router.push('/candidate/contact');
    },
    enterKeyPressed: function enterKeyPressed(event) {
      if (event.keyCode === 13) {
        this.validateCandidatePosition();
      }
    }
  }
});

/***/ }),

/***/ "S0aq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHWV":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"logo-coda",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15213.341 -11452 110.067 68.535","width":"110","height":"68"}},[_c('defs'),_c('g',{attrs:{"id":"Group_320","data-name":"Group 320","transform":"translate(-15213.341 -11452)"}},[_c('g',{attrs:{"id":"Group_318","data-name":"Group 318","transform":"translate(0 11.664)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_207","data-name":"Path 207","d":"M3229.405 158.721l-22.605-22.606 22.605-22.615 8.679 8.678-13.927 13.937 13.927 13.927z","transform":"translate(-3206.8 -113.5)"}})]),_c('g',{attrs:{"id":"Group_319","data-name":"Group 319","transform":"translate(78.712 11.613)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_208","data-name":"Path 208","d":"M3981.9 158.323l-8.7-8.7 13.958-13.957L3973.2 121.7l8.7-8.7 22.657 22.667z","transform":"translate(-3973.2 -113)"}})]),_c('path',{staticClass:"cls-2",attrs:{"id":"Rectangle_83","data-name":"Rectangle 83","transform":"rotate(-62.884 68.218 4.047)","d":"M0 0h70.691v12.314H0z"}})])])}}};

/***/ }),

/***/ "SVxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_minimal_svg__ = __webpack_require__("RH2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_minimal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_minimal_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Menu',
  data: function data() {
    return {};
  },

  computed: {
    className: function className() {
      return this.$store.getters.getMenuClass;
    }
  },
  components: {
    logoMinimal: __WEBPACK_IMPORTED_MODULE_0__assets_logo_minimal_svg___default.a
  },
  methods: {
    goToContact: function goToContact() {
      this.$router.push('/contact');
    }
  }
});

/***/ }),

/***/ "Tmdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('checkIcon',{directives:[{name:"magicheck",rawName:"v-magicheck"}],staticClass:"checkmark"})],1),_vm._v(" "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U2Sy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateType_vue__ = __webpack_require__("W3/s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73df4b6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateType_vue__ = __webpack_require__("Re2t");
function injectStyle (ssrContext) {
  __webpack_require__("l9lo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73df4b6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W3/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__ = __webpack_require__("8Sle");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import MainMenu from './MainMenu.vue'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CandidateType',
  data: function data() {
    return {
      select: {
        isOpen: false,
        value: 'Sou um estudante',
        choices: ['Sou um estudante', 'Sou um profissional júnior', 'Sou um profissional analista', 'Sou um profissional sênior', 'Sou um profissional lider']
      }
    };
  },

  components: {
    //      MainMenu,
    arrowBack: __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__["a" /* default */]
  },
  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    }
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', '');
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    goToCandidatePosition: function goToCandidatePosition() {
      this.$store.commit('setCandidateType', this.select.value);
      this.$router.push('candidate/position');
    },
    toggleFakeSelect: function toggleFakeSelect() {
      this.select.isOpen = !this.select.isOpen;
    },
    setSelectValue: function setSelectValue(val) {
      this.select.value = val;
      this.select.isOpen = false;
    },

    /**
     * Fecha as opções do select quando clicar na página
     * @param event
     */
    autoCloseSelect: function autoCloseSelect(event) {
      if ($('.fake-selector.open') !== null) {
        if (!$(event.target).is('.current')) {
          this.select.isOpen = false;
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "WSAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart Cart.vue full-container block"},[_c('div',{staticClass:"cart__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.goBack()}}},[_c('arrowBack',{attrs:{"id":"arrow-back"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"text-second animated fadeInDown delay1000ms"},[_vm._v("\n      Projetos novos são sempre motivantes e desafiadores. Nos informa quais serviços você precisa pra que possamos te\n      entender melhor ainda:\n    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"content animated fadeInUp delay1000ms"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 conteudo"},[_c('div',{staticClass:"video__ctn"},[_c('video',{staticStyle:{"max-height":"250px"},attrs:{"playsinline":"","preload":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/vod-conteudo.mp4","type":"video/mp4"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/media/vod-conteudo.gif","alt":""}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.toggleCheck()}}},[_c('checkboxSwitcher',{attrs:{"value":"Inbound Marketing,Performance,Gerenciamento de Redes Sociais"}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 inbound hidden"},[_c('div',{staticClass:"video__ctn"},[_c('video',{staticStyle:{"max-height":"250px"},attrs:{"playsinline":"","preload":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/vod-inbound.mp4","type":"video/mp4"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/media/vod-inbound.gif","alt":""}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.toggleCheck()}}},[_c('checkboxSwitcher')],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 tecnologia"},[_c('div',{staticClass:"video__ctn"},[_c('video',{staticStyle:{"max-height":"250px"},attrs:{"playsinline":"","preload":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/vod-tecnologia.mp4","type":"video/mp4"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/media/vod-tecnologia.gif","alt":""}})]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.toggleCheck()}}},[_c('checkboxSwitcher',{attrs:{"value":"Sites,E-commerce"}})],1),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 propaganda"},[_c('div',{staticClass:"video__ctn"},[_c('video',{staticStyle:{"max-height":"250px"},attrs:{"playsinline":"","preload":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/vod-campanha.mp4","type":"video/mp4"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/media/vod-campanha.gif","alt":""}})]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.toggleCheck()}}},[_c('checkboxSwitcher',{attrs:{"value":"Mídia Off"}})],1),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"btn-fixed hidden"},[_c('button',{staticClass:"btn btn-bold btn-lg btn-finish animated fadeIn",staticStyle:{"margin":"22px 0"},on:{"click":_vm.goToForm}},[_vm._v("Continuar")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title-primary animated fadeInDown delay1000ms"},[_vm._v("Legal "),_c('span',{staticClass:"sub"},[_vm._v("!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-header"},[_c('h3',[_vm._v("Bold Digital")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"choicesBox"},[_c('li',[_vm._v("Inbound Marketing")]),_vm._v(" "),_c('li',[_vm._v("Performance")]),_vm._v(" "),_c('li',[_vm._v("Gerenciamento de Redes Sociais")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-header"},[_c('h3',[_vm._v("Inbound")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"choicesBox"},[_c('li',[_vm._v("Inbound Marketing")]),_vm._v(" "),_c('li',[_vm._v("Conteúdo para blog")]),_vm._v(" "),_c('li',[_vm._v("SEO")]),_vm._v(" "),_c('li',[_vm._v("Criação de materiais ricos")]),_vm._v(" "),_c('li',[_vm._v("Gerenciamento de RD Station")]),_vm._v(" "),_c('li',[_vm._v("Fluxos de automação de E-mail")]),_vm._v(" "),_c('li',[_vm._v("Mídia Digital")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-header"},[_c('h3',[_vm._v("Bold Web")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"choicesBox"},[_c('li',[_vm._v("Sites")]),_vm._v(" "),_c('li',[_vm._v("E-commerce")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-header"},[_c('h3',[_vm._v("Bold Propaganda")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"choicesBox"},[_c('li',[_vm._v("Mídia Off")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WrGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("vrI1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d2c7b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("O7oi");
function injectStyle (ssrContext) {
  __webpack_require__("77hI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23d2c7b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d2c7b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XB5f":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-11283.506 -12406.674 21.812 25.848","width":"22","height":"25"}},[_c('defs'),_c('g',{attrs:{"id":"XMLID_1_","transform":"translate(-11283.506 -12406.674)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_22_","d":"M18.337 23.6a.749.749 0 0 0-.637.354v4.461a.979.979 0 0 0 .637.354c.354 0 .567-.354.567-.991v-3.187c0-.637-.212-.991-.567-.991zm0 0","transform":"translate(-5.166 -6.888)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_19_","d":"M25.137 23.6c-.425 0-.637.354-.637.991v.709h1.345v-.708c-.071-.637-.283-.991-.708-.991zm0 0","transform":"translate(-7.15 -6.888)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_12_","d":"M20.749 16.133a3.361 3.361 0 0 0-2.2-.921C15.509 15 10.906 15 10.906 15s-4.6 0-7.648.212a3.361 3.361 0 0 0-2.2.921 4.63 4.63 0 0 0-.85 2.124A34.058 34.058 0 0 0 0 21.8v1.629a34.058 34.058 0 0 0 .212 3.541 4.63 4.63 0 0 0 .85 2.124 3.689 3.689 0 0 0 2.408.921c1.77.142 7.436.212 7.436.212s4.6 0 7.648-.212a3.361 3.361 0 0 0 2.2-.921 4.63 4.63 0 0 0 .85-2.124 34.058 34.058 0 0 0 .212-3.541V21.8a31.852 31.852 0 0 0-.212-3.47 4.8 4.8 0 0 0-.85-2.2zM4.815 27.322H3.328v-8.427H1.77v-1.346h4.6v1.345H4.815zm5.17 0H8.639v-.779a2.175 2.175 0 0 1-1.487.921.777.777 0 0 1-.852-.564 3.45 3.45 0 0 1-.142-1.062V20.1h1.348v5.878a.259.259 0 0 0 .283.283q.425 0 .85-.637v-5.596h1.346zm5.028-2.2a7.514 7.514 0 0 1-.142 1.487 1 1 0 0 1-1.062.85 1.809 1.809 0 0 1-1.345-.779v.708h-1.346v-9.839h1.345v3.187a1.809 1.809 0 0 1 1.345-.779 1.108 1.108 0 0 1 1.062.85 6.444 6.444 0 0 1 .142 1.487zm4.957-1.2h-2.62V25.2c0 .708.212.991.708.991a.547.547 0 0 0 .567-.5v-.921h1.345v1.062a2.537 2.537 0 0 1-.283.779 1.92 1.92 0 0 1-1.629.779 2.014 2.014 0 0 1-1.629-.779 2.723 2.723 0 0 1-.425-1.7v-2.546a2.723 2.723 0 0 1 .425-1.7 1.947 1.947 0 0 1 3.116 0 2.723 2.723 0 0 1 .425 1.7v1.558zm0 0","transform":"translate(0 -4.378)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_9_","d":"M9.1 9.843V5.878L10.87 0H9.382L8.32 3.895 7.329 0H5.7c.283.921.637 1.841.921 2.762a21.568 21.568 0 0 1 .921 3.116v3.965zm0 0","transform":"translate(-1.664)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_5_","d":"M14.583 10.977a1.881 1.881 0 0 0 1.558-.779 2.723 2.723 0 0 0 .425-1.7V5.879a2.723 2.723 0 0 0-.425-1.7 1.947 1.947 0 0 0-3.116 0 2.723 2.723 0 0 0-.425 1.7v2.549a2.723 2.723 0 0 0 .425 1.7 1.7 1.7 0 0 0 1.558.85zm-.637-5.311c0-.708.212-.991.637-.991s.637.354.637.991v3.116c0 .708-.212.991-.637.991s-.637-.354-.637-.991zm0 0","transform":"translate(-3.677 -.992)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"XMLID_2_","d":"M23.424 10.894V3.6h-1.345v5.594q-.425.637-.85.637a.259.259 0 0 1-.283-.283V3.6H19.6v5.807a3.45 3.45 0 0 0 .142 1.062.854.854 0 0 0 .85.567 2.176 2.176 0 0 0 1.558-.921v.779zm0 0","transform":"translate(-5.72 -1.051)"}})])])}}};

/***/ }),

/***/ "XhTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-candidate FormCandidate.vue full-container block"},[_c('div',{staticClass:"form__content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goBack}},[_c('arrowBack',{attrs:{"id":"arrow-back"}})],1),_vm._v(" "),_c('h1',{staticClass:"title-primary animated fadeInUp delay1000ms"},[_vm._v("Pra finalizar, preenche teus dados.")]),_vm._v(" "),_c('form',{staticClass:"animated fadeInUp delay1500ms",on:{"submit":_vm.goToThanksPage}},[(!_vm.guestName)?_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Nome","maxlength":"50","required":""},domProps:{"value":(_vm.form.name)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Nome")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"bold-control",attrs:{"type":"email","placeholder":"E-mail","maxlength":"50","required":""},domProps:{"value":(_vm.form.email)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("E-mail")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control phone",attrs:{"pattern":"[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?","type":"text","placeholder":"00 0000.00000","maxlength":"13","required":""},on:{"keyup":_vm.chekEmptyField,"blur":_vm.chekEmptyField}}),_vm._v(" "),_c('label',[_vm._v("Telefone")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.linkedin),expression:"form.linkedin"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"LinkedIn","minlength":"5","maxlength":"200","required":""},domProps:{"value":(_vm.form.linkedin)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "linkedin", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Linkedin")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.facebook),expression:"form.facebook"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Facebook","minlength":"5","maxlength":"200"},domProps:{"value":(_vm.form.facebook)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "facebook", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Facebook")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.portfolio),expression:"form.portfolio"}],staticClass:"bold-control",attrs:{"type":"text","placeholder":"Portfólio","maxlength":"200"},domProps:{"value":(_vm.form.portfolio)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "portfolio", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Portfólio")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label textarea"},[_c('textarea',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"bold-control",attrs:{"placeholder":"Quer falar algo mais? Somos todos ouvidos...","minlength":"10","maxlength":"1024"},domProps:{"value":(_vm.form.message)},on:{"keyup":_vm.chekEmptyField,"keydown":_vm.resizeTextarea,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Mensagem")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-bold btn-lg btn-padding-lg",attrs:{"type":"submit"}},[_vm._v("enviar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xkyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_arrow_back_svg__ = __webpack_require__("kE1a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_arrow_back_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_arrow_back_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus__ = __webpack_require__("Jn6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vivus__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrowBack',
  data: function data() {
    return {
      timeoutPointer: false,
      anim: false
    };
  },

  props: {
    delay: {
      'type': Number,
      'default': 900
    },
    duration: {
      'type': Number,
      'default': 50
    }
  },
  mounted: function mounted() {
    var anim = new __WEBPACK_IMPORTED_MODULE_1_vivus___default.a(this.$el, {
      start: 'manual', // avoid memory leak o scroll event
      duration: this.duration,
      animTimingFunction: __WEBPACK_IMPORTED_MODULE_1_vivus___default.a.EASE_IN
    });
    this.anim = anim;
    anim.reset().stop();
    this.timeoutPointer = setTimeout(function () {
      try {
        anim.play();
      } catch (e) {}
    }, this.delay);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timeoutPointer);
    this.anim.stop().destroy();
  },

  components: {
    arrowBackIcon: __WEBPACK_IMPORTED_MODULE_0__assets_arrow_back_svg___default.a
  }
});

/***/ }),

/***/ "YSpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__ = __webpack_require__("8Sle");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BusinessStage',
  data: function data() {
    return {
      stageList: ['Estou começando um novo negócio/projeto.', 'Gostaria de um orçamento para minha empresa']
    };
  },

  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    },

    businessState: {
      get: function get() {
        return this.$store.state.client.businessState;
      },
      set: function set(value) {
        this.$store.commit('setBusinessStage', value);
      }
    }
  },
  watch: {
    guestType: function guestType(val) {
      if (val === 'candidate') {
        this.$router.push('candidate');
      } else if (val === 'client') {
        this.$router.push('/client/overview');
      }
    },
    businessState: function businessState(val) {
      if (val) {
        // this.$router.push('/client/cart')
        this.$router.push('/client/contact');
      }
    }
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);

    if (this.businessState !== '') {
      this.$store.commit('setBusinessStage', '');
    }

    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');

    if (!this.$store.state.guestName) {
      console.log('making fake guest...');
      this.$store.commit('setGuestName', '');
    }

    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1000);
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
      // this.$router.push('/client/overview');
    }
  },
  components: {
    arrowBack: __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__["a" /* default */],
    logo: __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default.a
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Bold__ = __webpack_require__("DrGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Splash__ = __webpack_require__("yacz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_GuestType__ = __webpack_require__("u06g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CandidateType__ = __webpack_require__("U2Sy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CandidatePosition__ = __webpack_require__("R5/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormCandidate__ = __webpack_require__("p85F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Thanks__ = __webpack_require__("79Ph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_client_Overview__ = __webpack_require__("WrGF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_client_BusinessStage__ = __webpack_require__("h53d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_client_Cart__ = __webpack_require__("pu3F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_client_FormClient__ = __webpack_require__("84ds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Error404__ = __webpack_require__("5Iau");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ContactForm__ = __webpack_require__("wCbp");


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
    template: '<router-view class="child-view"></router-view>',
    children: [{
      path: '/home',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Home__["a" /* default */]
    }, {
      path: '/',
      name: 'Splash',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Splash__["a" /* default */]
    }, {
      path: '/guest',
      name: 'GuestType',
      component: __WEBPACK_IMPORTED_MODULE_6__components_GuestType__["a" /* default */]
    }, {
      path: '/candidate',
      name: 'CandidateType',
      component: __WEBPACK_IMPORTED_MODULE_7__components_CandidateType__["a" /* default */]
    }, {
      path: '/candidate/position',
      name: 'CandidatePosition',
      component: __WEBPACK_IMPORTED_MODULE_8__components_CandidatePosition__["a" /* default */]
    }, {
      path: '/candidate/contact',
      name: 'FormCandidate',
      component: __WEBPACK_IMPORTED_MODULE_9__components_FormCandidate__["a" /* default */]
    }, {
      path: '/thanks',
      name: 'Thanks',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Thanks__["a" /* default */]
    }, {
      path: '/client/overview',
      name: 'Overview',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_Overview__["a" /* default */]
    }, {
      path: '/client/stage',
      name: 'BusinessStage',
      component: __WEBPACK_IMPORTED_MODULE_12__components_client_BusinessStage__["a" /* default */]
    }, {
      path: '/client/cart',
      name: 'Cart',
      component: __WEBPACK_IMPORTED_MODULE_13__components_client_Cart__["a" /* default */]
    }, {
      path: '/client/contact',
      name: 'FormClient',
      component: __WEBPACK_IMPORTED_MODULE_14__components_client_FormClient__["a" /* default */]
    }, {
      path: '/contact',
      name: 'ContactForm',
      component: __WEBPACK_IMPORTED_MODULE_16__components_ContactForm__["a" /* default */]
    }, {
      path: '/404',
      name: 'Error404',
      component: __WEBPACK_IMPORTED_MODULE_15__components_Error404__["a" /* default */]
    }]
  }, {
    path: '*',
    redirect: '/404'
  }]
}));

/***/ }),

/***/ "YdDI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bY4I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c6fc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cXxo":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"slide-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12285.993 -14134.072 23.544 41.422","width":"19","height":"38"}},[_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_184","data-name":"Path 184","d":"M-16549.963-12306.885l19.3 19.3 19.3-19.3","transform":"rotate(-90 -15310.86 -15333.166)"}})])}}};

/***/ }),

/***/ "caGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dL6C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__ = __webpack_require__("8Sle");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_404_svg__ = __webpack_require__("25eS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_404_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_404_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vivus__ = __webpack_require__("Jn6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vivus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vivus__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Error404',
  data: function data() {
    return {
      delay: 1000,
      anim: {}
    };
  },

  components: {
    arrowBack: __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__["a" /* default */],
    icon404: __WEBPACK_IMPORTED_MODULE_1__assets_404_svg___default.a
  },
  beforeDestroy: function beforeDestroy() {
    $(document).off('mousemove');
    this.anim.stop().destroy();
  },

  methods: {
    goHome: function goHome() {
      this.$router.push('/');
    }
  },
  mounted: function mounted() {
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');

    var anim = new __WEBPACK_IMPORTED_MODULE_2_vivus___default.a(document.querySelector('.icon404'), {
      start: 'manual', // avoid memory leak o scroll event
      duration: 20,
      animTimingFunction: __WEBPACK_IMPORTED_MODULE_2_vivus___default.a.EASE_IN
    });

    this.anim = anim;
    anim.reset().stop();
    this.timeoutPointer = setTimeout(function () {
      try {
        anim.play();
      } catch (e) {}
    }, this.delay);

    $(document).mousemove(function (event) {
      var eye = $(".buld");
      var x = eye.offset().left + eye.width() / 2;
      var y = eye.offset().top + eye.height() / 2;
      var rad = Math.atan2(event.pageX - x, event.pageY - y);
      var rot = rad * (180 / Math.PI) * -1 + 180;
      eye.css({
        '-webkit-transform': 'rotate(' + rot + 'deg)',
        '-moz-transform': 'rotate(' + rot + 'deg)',
        '-ms-transform': 'rotate(' + rot + 'deg)',
        'transform': 'rotate(' + rot + 'deg)'
      });
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "fhoZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fzFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__ = __webpack_require__("8Sle");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_mask_plugin__ = __webpack_require__("t+Rb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_mask_plugin__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormClient',
  data: function data() {
    return {
      contactType: '',
      objetivos: {
        'Aumentar as vendas da minha empresa': false,
        'Gerar leads para equipe de vendas': false,
        'Promover minha marca, criando autoridade e reconhecimento': false,
        'Lançar um produto (projeto especial)': false,
        'Outros objetivos': false
      },
      ferramentas: {
        'Whatsapp': false,
        'Ferramenta de automação de emails': false,
        'CRM': false
      },
      form: {
        name: '',
        email: '',
        telefone: '',
        company: '',
        como_podemos_ajudar: '',
        em_qual_segmento_a_sua_empresa_atua: '',
        segmento_outro: '',

        qual_seu_negocio_hotel: '',
        quantidade_acomodacao: '',
        ticket_medio_por_reserva: '',
        cargo: '',
        quanto_investe_em_midia: '',

        clinica_total_unidades: '',
        equipe_comercial_call_center_clinica: '',
        quantos_leads_por_mes_sua_empresa_gera: '',

        Mensagem: ''
      }
    };
  },

  watch: {
    'form.como_podemos_ajudar': function formComo_podemos_ajudar() {
      var _this = this;

      setTimeout(function () {
        _this.preCadastro();
      }, 100);
    }
  },
  computed: {
    objetivosValidos: function objetivosValidos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.objetivos).filter(function (key) {
        return _this2.objetivos[key];
      }).join(', ');
    },
    ferramentasValidas: function ferramentasValidas() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ferramentas).filter(function (key) {
        return _this3.ferramentas[key];
      }).join(', ');
    }
  },
  components: {
    //      MainMenu,
    arrowBack: __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', '');

    var $this = this;
    $('.phone').mask('00 0000.00009', {
      placeholder: 'Telefone',
      onChange: function onChange(val) {
        $this.form.Telefone = val;
      }
    });
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    $('.phone').unmask();
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getPostData: function getPostData(identificador) {
      var _this4 = this;

      var postData = [{ name: 'identificador', value: identificador }, { name: 'tok' + 'en_rds' + 'tation', value: '76d813f385092cd1' + 'c7a5e954a4c73c5e' }];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key) {
        if (_this4.form[key]) {
          postData.push({
            name: key,
            value: _this4.form[key]
          });
        }
      });

      if (this.objetivosValidos) {
        postData.push({
          name: 'quais_os_seus_objetivos_com_o_marketing_digital',
          value: this.objetivosValidos
        });
      }

      if (this.ferramentasValidas) {
        postData.push({
          name: 'ferramentas',
          value: this.ferramentasValidas
        });
      }
      return postData;
    },
    preCadastro: function preCadastro() {
      if (!form.como_podemos_ajudar) {
        return;
      }
      var postData = this.getPostData('pre_contato_cliente');
      RdIntegration.post(postData);
    },
    goToThanksPage: function goToThanksPage(event) {
      var $this = this;
      event.preventDefault();
      window.scroll(0, 0);

      var postData = this.getPostData('contato_cliente');

      $('.loading').removeClass('hideL');

      RdIntegration.post(postData, function () {
        $this.$router.push('/thanks');
      });

      return false;
    },
    resizeTextarea: function resizeTextarea(event) {
      var el = event.target;
      setTimeout(function () {
        el.style.cssText = 'height:auto;';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
      }, 0);
    },
    chekEmptyField: function chekEmptyField(event) {
      var el = $(event.target);
      if (el.val().length > 0) {
        el.parent().addClass('white');
      } else {
        el.parent().removeClass('white');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "g0rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__ = __webpack_require__("8Sle");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__("t+Rb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import MainMenu from './MainMenu.vue'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormCandidate',
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        linkedin: '',
        facebook: '',
        portfolio: '',
        message: ''
      }
    };
  },

  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    }
  },
  components: {
    //      MainMenu,
    arrowBack: __WEBPACK_IMPORTED_MODULE_0__arrowBack_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', '');

    var $this = this;
    $('.phone').mask('00 0000.00009', {
      onChange: function onChange(val) {
        $this.form.phone = val;
      },

      placeholder: 'Telefone'
    });
  },
  beforeDestroy: function beforeDestroy() {
    $('.phone').unmask();
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    goToThanksPage: function goToThanksPage(event) {
      var $this = this;
      event.preventDefault();
      window.scroll(0, 0);
      if (!this.guestName) {
        this.$store.commit('setGuestName', this.form.name);
      }

      var postData = [{ name: 'identificador', value: 'contato_candidato' }, { name: 'tok' + 'en_rds' + 'tation', value: '76d813f385092cd1' + 'c7a5e954a4c73c5e' }, { name: 'nome', value: this.$store.state.guestName }, { name: 'tipo', value: this.$store.state.candidate.type }, { name: 'vaga', value: this.$store.state.candidate.position }, { name: 'email', value: this.form.email }, { name: 'telefone', value: this.form.phone }, { name: 'linkedin', value: this.form.linkedin }, { name: 'facebook', value: this.form.facebook }, { name: 'portfolio', value: this.form.portfolio }, { name: 'mensagem', value: this.form.message }];

      $('.loading').removeClass('hideL');

      RdIntegration.post(postData, function () {
        $this.$router.push('/thanks');
      });

      return false;
    },
    resizeTextarea: function resizeTextarea(event) {
      var el = event.target;
      setTimeout(function () {
        el.style.cssText = 'height:auto;';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
      }, 0);
    },
    chekEmptyField: function chekEmptyField(event) {
      var el = $(event.target);
      if (el.val().length > 0) {
        el.parent().addClass('white');
      } else {
        el.parent().removeClass('white');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "gkEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guest GuestType.vue"},[_c('div',{staticClass:"content"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goBack()}}},[_c('arrowBack')],1),_vm._v(" "),_c('h1',{staticClass:"title-primary text-center animated fadeInDown delay1000ms"},[_vm._v("\n      Massa! "),_c('br'),_vm._v("\n      O que te fez chegar até a gente"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNameNotEmpty),expression:"isNameNotEmpty"}]},[_vm._v(", ")]),_c('span',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.guestName)+"?")])]),_vm._v(" "),_c('div',{staticClass:"choice-list animated fadeInDown delay1000ms"},[_c('div',{staticClass:"form-check",class:{'animated fadeCheck': _vm.isNotGuestType('client'), 'move-to-right':(_vm.guestType === 'client')}},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"form-check-label",class:{'white selected': (_vm.guestType === 'client')}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestType),expression:"guestType"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"guestType","value":"client"},domProps:{"checked":_vm._q(_vm.guestType,"client")},on:{"change":function($event){_vm.guestType="client"}}}),_vm._v(" "),_c('span'),_vm._v("\n            Gostaria de um orçamento para minha empresa.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-check",class:{'animated fadeCheck': _vm.isNotGuestType('candidate'), 'move-to-left':(_vm.guestType === 'candidate')}},[_c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"form-check-label",class:{'white selected': (_vm.guestType === 'candidate')}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guestType),expression:"guestType"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"guestType","value":"candidate"},domProps:{"checked":_vm._q(_vm.guestType,"candidate")},on:{"change":function($event){_vm.guestType="candidate"}}}),_vm._v(" "),_c('span'),_vm._v("\n            Sou um profissional/estudante\n            e quero trabalhar com vocês.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h53d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessStage_vue__ = __webpack_require__("YSpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36428a47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessStage_vue__ = __webpack_require__("CFEE");
function injectStyle (ssrContext) {
  __webpack_require__("BU9R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36428a47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hmBL":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"300","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 265 78"}},[_c('title',[_v("bold-loading")]),_c('circle',{staticClass:"dot dot1",attrs:{"cx":"85","cy":"38.56","r":"11.5","fill":"none","stroke":"#000","stroke-miterlimit":"10"}}),_c('circle',{staticClass:"dot dot2",attrs:{"cx":"134","cy":"38.56","r":"11.5","fill":"none","stroke":"#000","stroke-miterlimit":"10"}}),_c('circle',{staticClass:"dot dot3",attrs:{"cx":"183","cy":"38.56","r":"11.5","fill":"none","stroke":"#000","stroke-miterlimit":"10"}}),_c('path',{staticClass:"left",attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"14","d":"M63.5 18.5L45 37l19 19"}}),_c('path',{staticClass:"right",attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"14","d":"M205 57l18.99-18.99-19.5-19.5"}})])}}};

/***/ }),

/***/ "i9Ca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iNzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Bold',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "j/Tc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j6Wv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__ = __webpack_require__("8Sle");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import MainMenu from './MainMenu.vue'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GuestType',
  data: function data() {
    return {};
  },

  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    },

    guestType: {
      get: function get() {
        return this.$store.state.guestType;
      },
      set: function set(value) {
        this.$store.commit('setGuestType', value);
      }
    }
  },
  watch: {
    guestType: function guestType(val) {
      var $this = this;
      if (val === 'candidate') {
        setTimeout(function () {
          $this.$router.push('candidate');
        }, 700);
      } else if (val === 'client') {
        setTimeout(function () {
          $this.$router.push('/client/overview');
        }, 700);
      }
    }
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);

    if (this.guestType !== '') {
      this.$store.commit('setGuestType', '');
    }

    // seta a classe do menu principal
    this.$store.commit('setMenuClass', '');

    if (!this.$store.state.guestName) {
      console.log('making fake guest...');
      this.$store.commit('setGuestName', '');
    }
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    isNotGuestType: function isNotGuestType(val) {
      return this.guestType && this.guestType !== val;
    },
    isNameNotEmpty: function isNameNotEmpty() {
      return this.$store.state.guestName !== '';
    }
  },
  components: {
    arrowBack: __WEBPACK_IMPORTED_MODULE_1__arrowBack_vue__["a" /* default */],
    logo: __WEBPACK_IMPORTED_MODULE_0__assets_logo_svg___default.a
  }
});

/***/ }),

/***/ "jVZ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App.vue",attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid"},[_c('main-menu'),_vm._v(" "),_c('transition',{attrs:{"name":"customize","enter-active-class":_vm.transitionEnter,"leave-active-class":_vm.transitionLeave}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jvYG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kE1a":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"logo-back",attrs:{"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 34","width":"46","height":"34"}},[_c('g',{attrs:{"id":"Group_101","transform":"translate(-16697.107 -13626.546)"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M16726.9 13628.3H16731.3c5.5 0 9.9 4.5 9.8 9.9v.1c0 5.5-4.5 9.9-9.9 9.8h-31.3"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_48","d":"M16711 13659.3l-11.1-11.1 11.1-11.1"}})])])}}};

/***/ }),

/***/ "kk2J":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"checkmark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.2 15","width":"19","height":"15"}},[_c('path',{staticClass:"st0",attrs:{"data-ignore":"true","d":"M1 1h13v13H1z","id":"quardato"}}),_c('g',{attrs:{"id":"check"}},[_c('path',{staticClass:"st1",attrs:{"data-ignore":"true","d":"M0 0h15v15H0z"}}),_c('path',{staticClass:"st2",attrs:{"id":"Path_213","d":"M4.7 5.3l4.2 4.4 9.4-8.3"}})])])}}};

/***/ }),

/***/ "kyvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gyronorm__ = __webpack_require__("dw2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gyronorm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gyronorm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_script_loader_hughsk_fulltilt_dist_fulltilt__ = __webpack_require__("IZ50");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_script_loader_hughsk_fulltilt_dist_fulltilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_script_loader_hughsk_fulltilt_dist_fulltilt__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Splash',
  data: function data() {
    return {
      isAnimationDisabled: false,
      showWarningRipple: true
    };
  },

  components: {
    logo: __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default.a
  },
  beforeDestroy: function beforeDestroy() {
    try {
      this.gn.end();
      $('#scene1').off('mousemove');
    } catch (e) {}
  },
  mounted: function mounted() {
    this.log('mounted: ' + this.$options.name);

    // ativa animação

    this.enableDareAnimation();

    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'hidden');

    this.gn = new __WEBPACK_IMPORTED_MODULE_0_gyronorm___default.a();
    var gn = this.gn;

    var lastExecution = void 0;
    gn.init().then(function () {
      gn.start(function (data) {

        var now = Date.now();
        if (now - lastExecution < 50) return; // ~60Hz
        lastExecution = now;

        if (data.dm.gx !== 0) {
          var val = data.dm.gx;
          $('.splash__grid').css('background-position-x', val + 'px');
        }
      });
    }).catch(function (e) {
      // Catch if the DeviceOrientation or DeviceMotion is not supported by the browser or device
      console.log('DeviceMotion no supported');
    });
  },

  methods: {
    enableDareAnimation: function enableDareAnimation() {
      $('#scene1').on('mousemove', function (toto) {
        var val = toto.offsetX / 14;
        $('.splash__grid').css('background-position-x', val + 'px');
      });
    },

    /**
     * Toggler para animação do background
     */
    goToSite: function goToSite() {
      // if (this.isAnimationDisabled){
      //   this.showWarningRipple = true;
      // }else{
      this.$router.push('/home');
      // }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "l9lo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edf58f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("PvVz");
function injectStyle (ssrContext) {
  __webpack_require__("fhoZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edf58f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "naL6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p85F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCandidate_vue__ = __webpack_require__("g0rx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097b6d9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCandidate_vue__ = __webpack_require__("XhTC");
function injectStyle (ssrContext) {
  __webpack_require__("bY4I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCandidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097b6d9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCandidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pd/H":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{staticClass:"map-pin",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18559 -14306.298 30.309 43.142","width":"30","height":"43"}},[_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M-18543.846-14284.097a6.79 6.79 0 0 0 4.981-2.068 6.79 6.79 0 0 0 2.065-4.978 6.79 6.79 0 0 0-2.068-4.981 6.79 6.79 0 0 0-4.978-2.073 6.79 6.79 0 0 0-4.981 2.068 6.79 6.79 0 0 0-2.073 4.986 6.79 6.79 0 0 0 2.068 4.981 6.79 6.79 0 0 0 4.986 2.065zm0-11.4a4.324 4.324 0 0 1 4.346 4.354 4.324 4.324 0 0 1-4.346 4.346 4.324 4.324 0 0 1-4.348-4.348 4.324 4.324 0 0 1 4.348-4.348zm-.971 31.659a2.323 2.323 0 0 0 .675.591 1.1 1.1 0 0 0 .844 0 6.341 6.341 0 0 0 .675-.591q.507-.507 1.351-1.52t3.082-4.01q2.237-3 4.01-5.91a49.31 49.31 0 0 0 3.377-6.8 25.913 25.913 0 0 0 1.942-7.261 11.368 11.368 0 0 0 .169-1.857 14.556 14.556 0 0 0-4.432-10.68 14.606 14.606 0 0 0-10.722-4.421 14.606 14.606 0 0 0-10.722 4.432 14.556 14.556 0 0 0-4.432 10.68 11.818 11.818 0 0 0 .169 1.942 26.2 26.2 0 0 0 1.9 7.134 43.575 43.575 0 0 0 3.546 6.965q1.985 3.124 3.967 5.741t3.25 4.095a12.529 12.529 0 0 0 1.351 1.477zm.929-39.759a12.1 12.1 0 0 1 8.822 3.63 11.892 11.892 0 0 1 3.672 8.78 9.152 9.152 0 0 1-.169 1.6 25.817 25.817 0 0 1-1.815 6.8 38.279 38.279 0 0 1-3.672 6.965q-2.2 3.293-3.715 5.361t-2.954 3.844q-1.52-1.773-3.082-3.841t-3.756-5.362a42.542 42.542 0 0 1-3.757-6.965 24.184 24.184 0 0 1-1.9-6.8q-.084-.929-.084-1.6a11.961 11.961 0 0 1 3.63-8.78 11.961 11.961 0 0 1 8.78-3.632z"}})])}}};

/***/ }),

/***/ "pu3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__("OrSQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f41150a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__("WSAy");
function injectStyle (ssrContext) {
  __webpack_require__("B4ra")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f41150a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qPpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkMark_vue__ = __webpack_require__("23dS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc9c3d64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkMark_vue__ = __webpack_require__("Tmdg");
function injectStyle (ssrContext) {
  __webpack_require__("j/Tc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkMark_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc9c3d64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkMark_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sAd8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sIyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__ = __webpack_require__("AqYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_media_ico_facebook_svg__ = __webpack_require__("K04W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_media_ico_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_media_ico_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_media_ico_instagram_svg__ = __webpack_require__("5XGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_media_ico_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_media_ico_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_youtube_svg__ = __webpack_require__("XB5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_youtube_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_media_ico_youtube_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Thanks',
  data: function data() {
    return {};
  },

  components: {
    MainMenu: __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__["a" /* default */],
    logo: __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default.a,
    icoFace: __WEBPACK_IMPORTED_MODULE_2__static_media_ico_facebook_svg___default.a,
    icoInsta: __WEBPACK_IMPORTED_MODULE_3__static_media_ico_instagram_svg___default.a,
    icoYoutube: __WEBPACK_IMPORTED_MODULE_4__static_media_ico_youtube_svg___default.a

  },
  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    }
  },
  mounted: function mounted() {
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'no-logo');
    setTimeout(function () {
      $('.loading').addClass('hideL');
    }, 1000);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "u06g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestType_vue__ = __webpack_require__("j6Wv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ad2634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestType_vue__ = __webpack_require__("gkEe");
function injectStyle (ssrContext) {
  __webpack_require__("i9Ca")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ad2634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vGO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkboxSwitcher',
  data: function data() {
    return {
      id: null
    };
  },

  props: ['value'],
  methods: {
    inputValue: function inputValue(id) {
      if (id == '28') {
        return "Propaganda";
      } else if (id == '29') {
        return "Redes Sociais";
      } else if (id == '30') {
        return "Inbound";
      } else if (id == '31') {
        return "Tecnologia";
      }
    }
  },
  mounted: function mounted() {
    this.id = this._uid;
  }
});

/***/ }),

/***/ "vrI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_arrowBack_vue__ = __webpack_require__("8Sle");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_logo_minimal_svg__ = __webpack_require__("RH2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_logo_minimal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_logo_minimal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_coda_svg__ = __webpack_require__("SHWV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_coda_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_logo_coda_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_continuar_svg__ = __webpack_require__("GOfw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_media_ico_continuar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_media_ico_continuar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos__ = __webpack_require__("RInU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_script_loader_trial_js_trial_min__ = __webpack_require__("+mKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_script_loader_trial_js_trial_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_script_loader_trial_js_trial_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slugify__ = __webpack_require__("wffv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_slugify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Overview',
  components: {
    arrowBack: __WEBPACK_IMPORTED_MODULE_1__components_arrowBack_vue__["a" /* default */],
    logoMinimal: __WEBPACK_IMPORTED_MODULE_2__assets_logo_minimal_svg___default.a,
    logoCoda: __WEBPACK_IMPORTED_MODULE_3__assets_logo_coda_svg___default.a,
    arrow: __WEBPACK_IMPORTED_MODULE_4__static_media_ico_continuar_svg___default.a
  },
  data: function data() {
    return {
      parceiros: ['atalaia', 'atlantico', 'batista-leal', 'boa-vista', 'corveta', 'dental', 'ecocharme', 'ford-franca', 'gov-pe', 'greenmix', 'hair-fly', 'tambai', 'jeep-radar', 'locomotive', 'luck', 'palazzo', 'pro-crianca', 'renaut-lavie', 'tecon', 'yes', 'marmorart', 'max-plural', 'nissan', 'pharmapele', 'emporio-da-luz', 'real-derma', 'summerville', 'lojao-cabelereiro', 'trois-beaute', 'maremar-turismo', 'organo', 'ideiaria', 'spa-beaute', 'boris-berenstein', 'kia-francar', 'radar-ram', 'labelle-citroen', 'renault-la-vie', 'arpoador', 'labelle-peugeot', 'renault-marlin', 'botopremium', 'roval', 'cachoeira-fiat', 'mavel-fiat', 'sicredi', 'chery-jcf', 'mit-nami', 'sunhome', 'daf-nova', 'nissan-marlin', 'via-franca', 'fity', 'odontocompany', 'vitabrasil', 'grande-rio-fiat', 'radar-fiat', 'vrl', 'ipanema-inn', 'radar-jeep'],
      bosses: [{
        nome: 'Halisson',
        snome: 'Barreto',
        pos: ''
      }, {
        nome: 'Thiago',
        snome: 'Nascimento',
        pos: ''
      }],

      staff: [{
        nome: 'Alexandre',
        snome: 'Antunes',
        pos: ''
      }, {
        nome: 'Matheus',
        snome: 'Mendes',
        pos: ''
      }, {
        nome: 'Pedro',
        snome: 'Anjos',
        pos: ''
      }, {
        nome: 'Pedro',
        snome: 'Nascimento',
        pos: ''
      }, {
        nome: 'Rafael',
        snome: 'Zurc',
        pos: ''
      }, {
        nome: 'Samuel',
        snome: 'Barbosa',
        pos: ''
      }, {
        nome: 'Thiago',
        snome: 'Alves',
        pos: ''
      }, {
        nome: 'Williams',
        snome: 'Gomes',
        pos: ''
      }, {
        nome: 'Cristina',
        snome: 'Rocha',
        pos: ''
      }, {
        nome: 'Ricardo',
        snome: 'Nogueira',
        pos: ''
      }, {
        nome: 'Rossana',
        snome: 'Freitas',
        pos: ''
      }],
      pariaLimit: 0
    };
  },

  computed: {
    guestName: function guestName() {
      return this.$store.getters.guestFirstName;
    },
    orderedStaff: function orderedStaff() {
      var staff = this.staff,
          bosses = this.bosses,
          shuffle = this.shuffle;


      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(bosses), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(shuffle(staff)));
    }
  },

  mounted: function mounted() {
    var $this = this;
    this.log('mounted: ' + this.$options.name);
    var isMobile = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(navigator.userAgent);

    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');

    $('.h100').height(window.innerHeight + 'px');

    $(window).on('resize', function () {
      if (isMobile === false) {
        $('.h100').height(window.innerHeight + 'px');
        $('.section2 .left').attr('data-aos-offset', parseInt(window.innerHeight * 0.8));
      }
    });

    $('.section2 .left').attr('data-aos-offset', parseInt(window.innerHeight * 0.8));

    $(window).on('scroll', function () {
      if (isMobile === false) {
        var offset = $('.section2').offset().top - $(window).scrollTop();
        offset -= 60;

        var offset2 = $('.section4').offset().top - $(window).scrollTop();
        offset2 -= 60;

        if (offset2 > 0) {
          if (offset < 0) {
            $('.menu').removeClass('inverted');
          } else {
            $('.menu').addClass('inverted');
          }
        } else {
          $('.menu').addClass('inverted');
        }
      }
    });

    setTimeout(function () {
      $('.section2').removeClass('hidden');
      $('.section2,.section3,.section4').removeClass('hidden');

      // avoid multiple init
      if (!window.aos_started) {
        __WEBPACK_IMPORTED_MODULE_5_aos___default.a.init();
        window.aos_started = true;
      }

      // dirty hack to get the number of .heros per line
      var herosPerLines = Math.ceil(document.querySelector('.staff').offsetWidth / document.querySelector('.hero').offsetWidth);

      // console.log(herosPerLines);
      console.log(document.querySelector('.staff').offsetWidth);

      $this.pariaLimit = $this.orderedStaff.length - $this.orderedStaff.length % herosPerLines;
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    $(window).off('resize').off('scroll');
    Trial(".hero").off('within').off('leave');
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    isParia: function isParia(position) {
      return position + 1 > this.pariaLimit;
    },
    goToClientStage: function goToClientStage() {
      this.$router.push('/client/stage');
    },
    shuffle: function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var _ref = [a[j], a[i]];
        a[i] = _ref[0];
        a[j] = _ref[1];
      }
      return a;
    },
    goTo: function goTo(selector) {
      $('html, body').animate({
        scrollTop: $(selector).offset().top
      }, 500);
    },
    filePath: function filePath(id) {
      var _orderedStaff$id = this.orderedStaff[id],
          nome = _orderedStaff$id.nome,
          snome = _orderedStaff$id.snome;


      var fileName = [nome, snome].map(function (v) {
        return v.toLowerCase();
      }).join('-');

      return './static/media/people/' + __WEBPACK_IMPORTED_MODULE_7_slugify___default()(fileName) + '.jpg';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f33a23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("z2yx");
function injectStyle (ssrContext) {
  __webpack_require__("S0aq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f33a23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x7p7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("SVxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4dedbf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("5DZu");
function injectStyle (ssrContext) {
  __webpack_require__("ODYY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4dedbf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__ = __webpack_require__("x7p7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_media_loading_svg__ = __webpack_require__("hmBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_media_loading_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_media_loading_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snapsvg__ = __webpack_require__("o8uS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snapsvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_snapsvg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      transitionName: 'teste',
      transitionEnter: 'animated slideInRight',
      transitionLeave: 'animated slideOutLeft'
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.name !== 'Home' && !window.isDirty && to.name !== 'Error404') {
      next('/home');
    } else {
      next();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {

    if (to.name === 'Home' && from.name !== 'Splash' && from.name !== 'ContactForm' || to.name === 'GuestType' && from.name === 'CandidateType' || to.name === 'CandidateType' && from.name === 'CandidatePosition' || to.name === 'CandidatePosition' && from.name === 'FormCandidate' || to.name === 'Overview' && from.name === 'BusinessStage' || to.name === 'BusinessStage' && from.name === 'Cart' || to.name === 'Cart' && from.name === 'Thanks' || to.name === 'Cart' && from.name === 'FormClient' || to.name === 'Splash' && from.name === 'Home'
    // || (to.name === 'GuestType' && from.name === 'Overview')
    ) {
        // left to right
        this.transitionEnter = 'animated slideInLeft';
        this.transitionLeave = 'animated slideOutRight';
      } else if (to.name === 'BusinessStage' && from.name === 'Overview') {
      this.transitionEnter = 'animated slideInRight';
      this.transitionLeave = 'animated fadeOut';
    } else if (to.name === 'Error404') {
      this.transitionEnter = 'animated fadeIn';
      this.transitionLeave = 'animated fadeOut';
    } else if (to.name === 'ContactForm') {
      this.transitionEnter = 'animated slideInDown';
      // this.transitionLeave = 'animated slideOutDown'
      this.transitionLeave = 'animated fadeOut';
    } else if (from.name === 'ContactForm') {
      this.transitionEnter = 'animated slideInUp';
      this.transitionLeave = 'animated slideOutUp';
    } else if (to.name === 'Overview' && from.name === 'GuestType') {
      this.transitionEnter = 'animated slideInUp';
      this.transitionLeave = 'animated slideOutUp';
    } else {
      // right to left

      this.transitionEnter = 'animated slideInRight';
      this.transitionLeave = 'animated slideOutLeft';
    }
    console.log('from: ' + from.name);
    console.log('to: ' + to.name);
    next();
  },

  components: {
    MainMenu: __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_1__static_media_loading_svg___default.a
  },
  mounted: function mounted() {
    $('.loading').addClass('hideL');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "yacz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Splash_vue__ = __webpack_require__("kyvO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1eb8ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Splash_vue__ = __webpack_require__("L22p");
function injectStyle (ssrContext) {
  __webpack_require__("2QZE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Splash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1eb8ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Splash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z2yx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact ContactForm.vue full-container block"},[_c('div',{staticClass:"left animated slideInLeft"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('h1',[_c('logo')],1),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('mapPin'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"social"},[_c('a',{staticClass:"box-social",attrs:{"href":"https://www.facebook.com/boldcomunicacao/","target":"_blank"}},[_c('icoFace'),_vm._v(" "),_c('span',[_vm._v("Curta")])],1),_vm._v(" "),_c('a',{staticClass:"box-social",attrs:{"href":"https://www.instagram.com/boldcomunicacao","target":"_blank"}},[_c('icoInsta'),_vm._v(" "),_c('span',[_vm._v("Siga")])],1),_vm._v(" "),_c('a',{staticClass:"box-social",attrs:{"href":"https://www.youtube.com/channel/UCyp4B226-dw25ROkQujTXtw","target":"_blank"}},[_c('icoYoutube'),_vm._v(" "),_c('span',[_vm._v("Inscreva-se")])],1)])],1)])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"form__content"},[_c('form',{attrs:{"action":""},on:{"submit":_vm.submitForm}},[_c('div',{staticClass:"close-ctn"},[_c('div',{staticClass:"close",on:{"click":_vm.goBack}})]),_vm._v(" "),_c('h1',{staticClass:"title-primary"},[_vm._v("Quer mandar uma mensagem breve?")]),_vm._v(" "),_c('div',{staticClass:"sub"},[_vm._v("\n          Fique à vontade! "),_c('br'),_vm._v("\n          Caso queira um atendimento mais personalizado continue o "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.goToHome}},[_vm._v("fluxo do site.")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"bold-control inverted",attrs:{"type":"text","placeholder":"nome","maxlength":"50","required":""},domProps:{"value":(_vm.form.name)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("nome")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"}],staticClass:"bold-control inverted phone",attrs:{"pattern":"[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?","type":"text","placeholder":"celular","maxlength":"13","required":""},on:{"keyup":_vm.chekEmptyField,"blur":_vm.chekEmptyField}}),_vm._v(" "),_c('label',[_vm._v("celular")])]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label"},[_c('input',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"bold-control inverted",attrs:{"type":"email","placeholder":"e-mail","maxlength":"50","required":""},domProps:{"value":(_vm.form.email)},on:{"keyup":_vm.chekEmptyField,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("e-mail")])]),_vm._v(" "),_c('div',{staticClass:"fake-selector",class:{'open': _vm.select.isOpen}},[_c('div',{staticClass:"current",on:{"click":_vm.toggleFakeSelect}},[_vm._v("\n            "+_vm._s(_vm.select.value)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"escolhas animated zoomIn"},_vm._l((_vm.select.choices),function(item){return _c('span',{class:{'selected': _vm.select.value === item},on:{"click":function($event){return _vm.setSelectValue(item)}}},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group fake-label textarea"},[_c('textarea',{directives:[{name:"fakelabel",rawName:"v-fakelabel"},{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"bold-control inverted",attrs:{"placeholder":"Somos todos ouvidos...","minlength":"10","maxlength":"1024","required":""},domProps:{"value":(_vm.form.message)},on:{"keyup":_vm.chekEmptyField,"keydown":_vm.resizeTextarea,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("mensagem")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-bold inverted btn-lg btn-padding-lg",attrs:{"type":"submit"}},[_vm._v("enviar")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address"},[_vm._v("\n            Rua Dona Magina Pontual, 384 "),_c('br'),_vm._v("\n            Boa Viagem - CEP: 51.021-510 - Recife - Brazil"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n           Telefone: "),_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"href":"tel:8130193566"}},[_vm._v("(81) 3019-3566")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n\n            WhatsApp: "),_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"href":"https://wa.me/558130193566?text=Olá, entrei em contato via boldcomunicacao.com.br"}},[_vm._v("(81) 3019-3566")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/media/ico-whatsapp.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a45a598406deae63edc9.js